import {
  useContext,
  useEffect,
  useMemo,
  useState,
  useRef,
  useCallback,
} from "react";
import { Container } from "react-bootstrap";
import { FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { FaPlus, FaMinus, FaSquareWhatsapp } from "react-icons/fa6";
import "../Styles/Home.css";
import Banner from "./Banner";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Drawer, Tooltip } from "antd";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CoinBalance from "./CoinBalance";
import { WalletContext } from "../WalletContext";
import RatingModal from "./RatingModal";
import { BiSolidOffer } from "react-icons/bi";
import Swal2 from "sweetalert2";
import IsVeg from "../assets/isVeg=yes.svg";
import IsNonVeg from "../assets/isVeg=no.svg";
import MultiCartDrawer from "./MultiCartDrawer";
import DateSessionSelector from "./DateSessionSelector";
import {
  SESSION_ORDER,
  buildAvailabilityMap,
  dateKey,
  getCutoff,
  getWindowEnd,
  hasMenu,
  isPastCutoff,
  isWindowOpen,
  normalizeToUTCMidnight,
  resolveSessionSlot,
} from "../Helper/sessionAvailability";
import {
  getCachedHubData,
  readStoredAddress,
  resolveHubId,
  setCachedHubData,
} from "../Helper/hubDataCache";
import chef from "./../assets/chef_3.png";
import { Colors } from "../Helper/themes";
import checkCircle from "./../assets/check_circle.png";
import BottomNav from "./BottomNav";
import availabity from "./../assets/weui_done2-filled.png";
import { addToCart, reconcileCart } from "../Helper/cartHelper";
import Footer from "./Footer";
import CutoffStatusCard from "./../Helper/CutoffTimer.jsx";
import { MdDeliveryDining, MdOutlineTimer } from "react-icons/md";
import FreshIngredientsCarousel from "./FreshIngredientsCarousel.jsx";
import confetti from "canvas-confetti";
import cross from "../assets/cross.png";
import dishImg from "../assets/dish.png";
import combosImg from "../assets/combos3cp.png";
import { BsCartPlus } from "react-icons/bs";
import freemeal from "./../assets/freemeal.png";
import OfferUnlockedModal from "./OfferUnlockedModal";
import PreorderInfoModal from "./PreorderInfoModal";
import FreeMealBanner from "./FreeMealBanner.jsx";
import WhyDailyDishBar from "./WhyDailyDishBar.jsx";
// import SundayClosedModal from "./SundayClosedModal"; // RETIRED — replaced by deep-cleaned pill in CutoffTimer.jsx
import { io } from "socket.io-client";

// "20:00" -> "8:00 PM". Returns "" for anything unparseable so callers can hide the hint.
const formatCutoffTime = (hhmm) => {
  if (!hhmm) return "";
  const [h, m] = String(hhmm).split(":").map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return "";
  const period = h >= 12 ? "PM" : "AM";
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return `${hour12}:${String(m).padStart(2, "0")} ${period}`;
};

const fireToast = ({ title, subtitle, icon = checkCircle }) => {
  Swal2.fire({
    toast: true,
    position: "bottom",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    html: `
      <div class="myplans-toast-content">
        <img src="${icon}" alt="" class="myplans-toast-check" />
        <div class="myplans-toast-text">
          <div class="myplans-toast-title">${title}</div>
          ${subtitle ? `<div class="myplans-toast-subtitle">${subtitle}</div>` : ""}
        </div>
      </div>
    `,
    customClass: {
      popup: "myplans-custom-toast",
      htmlContainer: "myplans-toast-html",
    },
    didOpen: () => {
      const toast = document.querySelector(".myplans-custom-toast");
      if (toast) {
        toast.style.bottom = "60px";
        toast.style.left = "50%";
        toast.style.transform = "translateX(-50%)";
        toast.style.position = "fixed";
        toast.style.zIndex = "999999";
      }
    },
  });
};

const fmt12h = (hhmm) => {
  if (!hhmm) return "";
  const [h, m] = hhmm.split(":").map(Number);
  const ampm = h >= 12 ? "PM" : "AM";
  const h12 = h % 12 || 12;
  return `${h12}:${String(m).padStart(2, "0")} ${ampm}`;
};

// Sticky wrapper: sits in normal flow, switches to fixed when scrolled past top
const CutoffStickyWrapper = ({ children }) => {
  const placeholderRef = useRef(null);
  const [isFixed, setIsFixed] = useState(false);
  const [barHeight, setBarHeight] = useState(0);
  const barRef = useRef(null);

  useEffect(() => {
    const placeholder = placeholderRef.current;
    if (!placeholder) return;

    const onScroll = () => {
      const rect = placeholder.getBoundingClientRect();
      setIsFixed(rect.top <= 0);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll(); // run once on mount
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (barRef.current) {
      setBarHeight(barRef.current.offsetHeight);
    }
  });

  return (
    <>
      {/* Placeholder keeps the space so content below doesn't jump when bar goes fixed */}
      <div ref={placeholderRef} style={{ height: isFixed ? barHeight : 0 }} />
      <div
        ref={barRef}
        style={
          // overflow must stay visible: the offer dropdown panel inside
          // CutoffStatusCard extends below the bar (overflowX: hidden would
          // create a clip context and cut it off). Nothing inside the bar
          // overflows horizontally.
          isFixed
            ? {
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                zIndex: 999,
                width: "100%",
                maxWidth: "100vw",
              }
            : {
                width: "100%",
              }
        }
      >
        {children}
      </div>
    </>
  );
};

const Home = ({ selectArea, setSelectArea, Carts, setCarts }) => {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch {
      return null;
    }
  });

  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === "user") {
        try {
          setUser(JSON.parse(e.newValue));
        } catch {
          setUser(null);
        }
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  const updateUser = (userObj) => {
    setUser(userObj);
    if (userObj) {
      localStorage.setItem("user", JSON.stringify(userObj));
    } else {
      localStorage.removeItem("user");
    }
    window.dispatchEvent(new Event("userUpdated"));
  };

  const navigate = useNavigate();
  const location = useLocation();

  const { wallet, transactions } = useContext(WalletContext);

  // The address is read from localStorage during state init, not in an effect: a first
  // render without a hub makes the fetch effect clear everything and paint the
  // "no menu / Add Location" empty state before we have even asked the server.
  const initialAddress = useMemo(() => readStoredAddress().address, []);
  const initialHubId = useMemo(
    () => resolveHubId(initialAddress, user),
    [initialAddress, user],
  );
  // Cached from a previous mount (module scope survives the trip to /checkout), so
  // coming back paints instantly instead of blocking on a refetch.
  const initialCache = useMemo(
    () => getCachedHubData(initialHubId),
    [initialHubId],
  );

  const [loader, setloader] = useState(!initialCache && Boolean(initialHubId));
  const [allHubMenuData, setAllHubMenuData] = useState(
    initialCache?.menu || [],
  );
  // Which hub the menu currently in state belongs to. On a hub switch the
  // refetch effect runs AFTER the first paint, so without this tag the old
  // hub's menu renders for a frame (e.g. the "See tomorrow" switch flashes).
  const [menuHubId, setMenuHubId] = useState(
    initialCache ? initialHubId : null,
  );
  const [isVegOnly, setIsVegOnly] = useState(false);
  // Menu categories are no longer surfaced as pills. The grid always renders the
  // "Build Your Meal" category; "Combos" lives behind the Customise card's modal.
  const [showCombosModal, setShowCombosModal] = useState(false);
  const [address, setAddress] = useState(initialAddress);
  const [shouldLoadDefaultMenu, setShouldLoadDefaultMenu] = useState(
    !user && !initialAddress,
  );

  // Computed hub ID: use address.hubId if available, otherwise default hub for guests
  const effectiveHubId = useMemo(
    () => resolveHubId(address, user),
    [address?.hubId, user],
  );

  // True when a logged-in user has no delivery address set.
  // Used both by DateSessionSelector (to swap the empty-state card) and by the
  // finalDisplayItems fallback block below.
  const noLocation =
    !!user &&
    !address?.hubId &&
    (!localStorage.getItem("primaryAddress") ||
      localStorage.getItem("primaryAddress") === "null");

  const [cutoffValidation, setCutoffValidation] = useState({
    allowed: true,
    message: "",
    cutoffDateTime: null,
    nextAvailableDateTime: null,
    orderMode: "preorder",
  });
  const [cutoffLoading, setCutoffLoading] = useState(false);
  const [hubOrderMode, setHubOrderMode] = useState("preorder");
  const [hubLocalCutoffData, setHubLocalCutoffData] = useState(
    initialCache?.cutoff || null,
  ); // local cutoff times for instant checks
  const [hubSettled, setHubSettled] = useState(false); // true once auto-jump has completed for the current hub
  const [gifUrl, setGifUrl] = useState("");
  const [message, setMessage] = useState("");
  const [ordersLoaded, setOrdersLoaded] = useState(false);
  // userOrderCount = total orders placed by this user (for customerType eligibility)
  const [userOrderCount, setUserOrderCount] = useState(0);
  // New offer management: tracks which date|session|hubId slots the user has used an offer on
  const [userOfferStatus, setUserOfferStatus] = useState({
    usedOfferCount: 0,
    usedSlots: [],
  });
  const [offerStatusLoaded, setOfferStatusLoaded] = useState(false);

  // Acquisition offer (hubOffer) eligibility state for the home banner
  const [acqOfferStatus, setAcqOfferStatus] = useState(null);
  // null = not fetched yet, false = not eligible, object = eligible details

  // Offer unlocked modal — shown when arriving from UpdateLocation with a fresh hubOffer
  const [showOfferModal, setShowOfferModal] = useState(false);
  const [offerModalData, setOfferModalData] = useState(null);

  // "Why DailyDish?" info modal — opened from the minimal link below the
  // date/session selector (trigger moved out of the cutoff strip)
  const [showWhyModal, setShowWhyModal] = useState(false);

  // "Closed on Sundays" heads-up — shown once per day (IST) when it's Sunday,
  // to logged-in customers only. "Pending" rather than "show": when the offer
  // unlocked modal is also up, this one queues behind it (see isOpen below).
  const [sundayModalPending, setSundayModalPending] = useState(false);
  const [sundayMondayLabel, setSundayMondayLabel] = useState("");

  useEffect(() => {
    if (!user?._id) return; // logged-out visitors never see it

    // Compute "now" in India time regardless of the device's timezone.
    const istNow = new Date(
      new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }),
    );
    if (istNow.getDay() !== 0) return; // 0 = Sunday

    // Once per Sunday: remember dismissal keyed to today's IST date.
    const todayKey = `${istNow.getFullYear()}-${istNow.getMonth() + 1}-${istNow.getDate()}`;
    if (localStorage.getItem("ddSundayClosedDismissed") === todayKey) return;

    // Tomorrow (Monday) label for the copy, e.g. "Mon, 13 Jul".
    const monday = new Date(istNow);
    monday.setDate(monday.getDate() + 1);
    setSundayMondayLabel(
      monday.toLocaleDateString("en-IN", {
        weekday: "short",
        day: "numeric",
        month: "short",
      }),
    );
    setSundayModalPending(true);
  }, [user?._id]);

  const dismissSundayModal = () => {
    const istNow = new Date(
      new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }),
    );
    const todayKey = `${istNow.getFullYear()}-${istNow.getMonth() + 1}-${istNow.getDate()}`;
    localStorage.setItem("ddSundayClosedDismissed", todayKey);
    setSundayModalPending(false);
  };

  // Auto-switch tracking refs
  const autoSwitchInProgressRef = useRef(null); // stores last switched "date|session" key to prevent re-firing
  const [currentTime, setCurrentTime] = useState(new Date());

  // Update current time every second for precise cutoff checking
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Window feature state
  const [windowProducts, setWindowProducts] = useState([]);
  const [windowQtyMap, setWindowQtyMap] = useState({});
  const [windowProductsLoading, setWindowProductsLoading] = useState(false);
  // "session|YYYY-MM-DD" the window products in state actually belong to. Until a fetch
  // lands for the current selection, windowProducts is stale/empty and must NOT be read
  // as "this window is sold out" — that misread bounced a freshly clicked window session
  // straight back to the next day.
  const [windowFetchKey, setWindowFetchKey] = useState(null);
  // Window products for every open window, fetched up-front so that clicking a window
  // session paints from memory like breakfast/dinner do, instead of waiting on a request.
  const windowCacheRef = useRef({});
  // { lunch: portionsLeft, … } for the sessions whose window is open right now.
  const [windowCounts, setWindowCounts] = useState(null);
  const socketRef = useRef(null);
  const prevIsInWindowRef = useRef(null);

  // The socket effect mounts once, so its handler cannot close over windowProducts.
  // It reads this ref to learn which pool each product is drawing from.
  const windowProductsRef = useRef([]);
  useEffect(() => {
    windowProductsRef.current = windowProducts;
  }, [windowProducts]);

  // Fetch user order count for customerType eligibility check
  const fetchUserOrderCounts = async (userId) => {
    if (!userId) {
      console.log("[Offer] fetchUserOrderCounts: no userId, setting count=0");
      setUserOrderCount(0);
      setOrdersLoaded(true);
      return;
    }
    try {
      const res = await axios.get("https://dailydish.in/api/admin/count", {
        params: { userId },
      });
      // console.log(
      //   "[Offer] fetchUserOrderCounts response:",
      //   res.status,
      //   res.data,
      // );
      if (res.status === 200 && res.data?.success) {
        const count = res.data.count ?? 0;
        // console.log("[Offer] userOrderCount set to:", count);
        setUserOrderCount(count);
        setOrdersLoaded(true);
      }
    } catch (error) {
      console.error("[Offer] fetchUserOrderCounts error:", error);
    } finally {
      setOrdersLoaded(true);
    }
  };

  // Fetch user offer status: which date|session|hubId slots have been used
  const fetchUserOfferStatus = async (userId) => {
    if (!userId || user?.status === "Employee") {
      console.log(
        "[Offer] fetchUserOfferStatus: no userId or Employee, skipping",
      );
      setUserOfferStatus({ usedOfferCount: 0, usedSlots: [] });
      setOfferStatusLoaded(true);
      return;
    }
    try {
      const res = await axios.get(
        "https://dailydish.in/api/admin/hub-menu/user-offer-status",
        { params: { userId } },
      );
      // console.log(
      //   "[Offer] fetchUserOfferStatus response:",
      //   res.status,
      //   res.data,
      // );
      if (res.status === 200 && res.data?.success) {
        // console.log(
        //   "[Offer] userOfferStatus set to:",
        //   res.data.usedOfferCount,
        //   res.data.usedSlots,
        // );
        setUserOfferStatus({
          usedOfferCount: res.data.usedOfferCount ?? 0,
          usedSlots: res.data.usedSlots ?? [],
        });
      }
    } catch (e) {
      console.error("[Offer] fetchUserOfferStatus error:", e);
    } finally {
      setOfferStatusLoaded(true);
    }
  };

  useEffect(() => {
    if (Carts?.length > 0) handleShow();
    // Refresh order count and offer status when user changes (also runs on mount)
    const refresh = async () => {
      setOfferStatusLoaded(false);
      setOrdersLoaded(false);
      await fetchUserOrderCounts(user?._id);
      await fetchUserOfferStatus(user?._id);
      // Fetch acquisition offer (hubOffer) eligibility
      if (user?._id && user?.status !== "Employee") {
        try {
          const res = await axios.get(
            `https://dailydish.in/api/offer/acquisition/status/${user._id}`,
          );
          // Store full response — includes usedToday state for "come back tomorrow" banner
          if (res.data?.eligible || res.data?.usedToday) {
            setAcqOfferStatus(res.data);
          } else {
            setAcqOfferStatus(false);
          }
        } catch {
          setAcqOfferStatus(false);
        }
      } else {
        setAcqOfferStatus(false);
      }
    };
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?._id]);

  // Show offer unlocked modal when navigating here from UpdateLocation with a fresh offer
  useEffect(() => {
    if (location.state?.offerUnlocked) {
      setOfferModalData(location.state.offerUnlocked);
      setShowOfferModal(true);
      // Clear the flag from history so it doesn't re-show on refresh/back-nav
      window.history.replaceState(
        {
          ...window.history.state,
          usr: { ...location.state, offerUnlocked: undefined },
        },
        "",
      );
    }
  }, [location.state?.offerUnlocked]);

  // Returns total order count for the current user
  const findNumberofOrders = () => {
    if (!user?._id) return 0;
    return userOrderCount;
  };

  // Convert backend UTC time to IST display time
  const convertUTCToISTDisplay = (utcDateString) => {
    if (!utcDateString) return null;

    const utcDate = new Date(utcDateString);
    let utcHours = utcDate.getUTCHours();
    let utcMinutes = utcDate.getUTCMinutes();

    let displayUTCHours = utcHours - 5;
    let displayUTCMinutes = utcMinutes - 30;

    if (displayUTCMinutes < 0) {
      displayUTCHours -= 1;
      displayUTCMinutes += 60;
    }

    if (displayUTCHours < 0) {
      displayUTCHours += 24;
    }

    const correctedDate = new Date(utcDate);
    correctedDate.setUTCHours(displayUTCHours, displayUTCMinutes, 0, 0);

    return correctedDate;
  };

  const formatTime12Hour = (date) => {
    if (!date) return null;

    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12;

    const minutesStr = minutes < 10 ? `0${minutes}` : minutes;

    return `${hours}:${minutesStr} ${ampm}`;
  };

  const validateCutoffTiming = useCallback(
    async (hubId, session, deliveryDate) => {
      if (!hubId || !session) return true;
      try {
        setCutoffLoading(true);
        const status = user?.status === "Employee" ? "Employee" : "Normal";

        // console.log("[validateCutoffTiming] Request:", {
        //   hubId,
        //   session: session.toLowerCase(),
        //   status,
        //   deliveryDate:
        //     deliveryDate instanceof Date
        //       ? deliveryDate.toISOString()
        //       : deliveryDate,
        // });

        const response = await axios.post(
          "https://dailydish.in/api/Hub/validate-order-timing",
          {
            hubId: hubId,
            session: session.toLowerCase(),
            status: status,
            deliveryDate:
              deliveryDate instanceof Date
                ? deliveryDate.toISOString()
                : deliveryDate,
          },
        );

        if (response.status === 200) {
          // console.log(
          //   "[validateCutoffTiming] Raw API response:",
          //   response.data,
          // );

          const rawCutoff = response.data.cutoffDateTime
            ? new Date(response.data.cutoffDateTime)
            : null;
          const rawNext = response.data.nextAvailableDateTime
            ? new Date(response.data.nextAvailableDateTime)
            : null;

          // Backend runs on Render/AWS (UTC) and adds IST offset when calculating cutoff
          // We need to subtract 5:30 hours (19800000 ms) to get the correct local time
          const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000; // 19800000 ms
          const correctedCutoff = rawCutoff
            ? new Date(rawCutoff.getTime() - IST_OFFSET_MS)
            : null;
          const correctedNext = rawNext
            ? new Date(rawNext.getTime() - IST_OFFSET_MS)
            : null;

          // console.log("[validateCutoffTiming] Corrected times:", {
          //   rawCutoff: rawCutoff?.toISOString(),
          //   correctedCutoff: correctedCutoff?.toISOString(),
          //   now: new Date().toISOString(),
          //   allowed: response.data.allowed,
          // });

          const validationData = {
            allowed: response.data.allowed,
            message: response.data.message,
            cutoffDateTime: correctedCutoff,
            nextAvailableDateTime: correctedNext,
            orderMode: response.data.orderMode || "preorder",
            // Stamp the session+date this validation was fetched for so stale
            // results from a previous session don't bleed into the current view.
            _forSession: session.toLowerCase(),
            _forDate:
              deliveryDate instanceof Date
                ? deliveryDate.toISOString().split("T")[0]
                : new Date(deliveryDate).toISOString().split("T")[0],
          };

          setCutoffValidation(validationData);
          setHubOrderMode(response.data.orderMode || "preorder");
          return response.data.allowed;
        }
        return true;
      } catch (error) {
        console.error("Error validating cutoff timing:", error);
        return true;
      } finally {
        setCutoffLoading(false);
      }
    },
    [user?.status],
  );

  const getNormalizedToday = () => {
    const now = new Date();
    return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
  };

  // Fetch hub cutoff times locally so we can do instant (no-API) cutoff checks
  // NOTE: This is now handled inside the combined hub+menu fetch below.

  // Pure local check — no API, instant
  const isSessionPastCutoffLocal = useCallback(
    (session, checkTime = new Date()) =>
      isPastCutoff(
        session,
        checkTime,
        hubLocalCutoffData,
        user?.status === "Employee",
      ),
    [hubLocalCutoffData, user?.status],
  );

  const [selectedDate, setSelectedDate] = useState(() => {
    if (location.state?.targetDate) return new Date(location.state.targetDate);
    return getNormalizedToday();
  });

  const [selectedSession, setSelectedSession] = useState(() => {
    if (location.state?.targetSession) return location.state.targetSession;
    return "Lunch";
  });

  // Reported by DateSessionSelector when every session is closed/coming-soon —
  // lets us skip the redundant "no items for this slot" message below.
  const [allSessionsClosedToday, setAllSessionsClosedToday] = useState(false);

  // Stable "YYYY-MM-DD" for the selection — effects key off this rather than the Date
  // object, whose identity changes on every setSelectedDate even for the same day.
  const selectedDateKey = useMemo(
    () => (selectedDate ? dateKey(selectedDate) : null),
    [selectedDate],
  );

  // True when the selected date is today (local timezone comparison)
  const isViewingToday = useMemo(() => {
    const now = new Date();
    return (
      now.getFullYear() === selectedDate.getFullYear() &&
      now.getMonth() === selectedDate.getMonth() &&
      now.getDate() === selectedDate.getDate()
    );
  }, [selectedDate]);

  // True when inside the post-cutoff ordering window for the current instant-mode session
  const isInWindow = useMemo(() => {
    if (hubOrderMode !== "instant") return false;
    if (!isViewingToday) return false;
    const key = selectedSession?.toLowerCase();
    const times = hubLocalCutoffData?.cutoffTimes?.[key];
    if (!times?.windowEnabled || !times?.windowEnd) return false;
    const IST_MS = 5.5 * 60 * 60 * 1000;
    const ist = new Date(currentTime.getTime() + IST_MS);
    const nowMins = ist.getUTCHours() * 60 + ist.getUTCMinutes();
    const [ch, cm] = (times.defaultCutoff || "0:0").split(":").map(Number);
    const [wh, wm] = times.windowEnd.split(":").map(Number);
    return nowMins >= ch * 60 + cm && nowMins < wh * 60 + wm;
  }, [
    hubOrderMode,
    hubLocalCutoffData,
    selectedSession,
    currentTime,
    isViewingToday,
  ]);

  // Portions still sellable in the current window. windowQtyMap is kept live by the
  // qty socket, so this drops to 0 the moment the last portion goes.
  const liveWindowCount = useMemo(() => {
    return windowProducts.filter((p) => {
      const pid = String(p.productId?._id || p.productId);
      const remaining = windowQtyMap[pid] ?? p.windowRemainingQuantity;
      return remaining === undefined || remaining === null
        ? true
        : Number(remaining) > 0;
    }).length;
  }, [windowProducts, windowQtyMap]);

  // True once the products in state belong to the selection we are actually looking at.
  const windowCountReady =
    isInWindow &&
    !windowProductsLoading &&
    windowFetchKey === `${selectedSession}|${selectedDateKey}`;

  // Per-session window counts handed to DateSessionSelector: the prefetched counts for
  // every open window, with the selected session overridden by the live, socket-updated
  // count. null while nothing is known yet, so an uncounted window stays "assume live"
  // rather than being misread as empty.
  const windowItemsBySession = useMemo(() => {
    const known = windowCounts ? { ...windowCounts } : null;
    if (windowCountReady && selectedSession) {
      return {
        ...(known || {}),
        [selectedSession.toLowerCase()]: liveWindowCount,
      };
    }
    return known;
  }, [windowCounts, windowCountReady, selectedSession, liveWindowCount]);

  // An open window is treated as live until its count says otherwise: while the count is
  // unknown (fetch in flight, or products still belonging to a previous selection) we
  // hold position rather than moving the user off a window that may well have portions.
  const isWindowLive = isInWindow && (!windowCountReady || liveWindowCount > 0);

  // Auto-switch when the selected session's cutoff is reached.
  // The session is preserved: we move to the next DATE that still has that session
  // (Breakfast closing at 7 AM → tomorrow's Breakfast, not today's Lunch).
  // If that session has no menu anywhere in the horizon, we stay put and the
  // selector renders it as "Serving Soon".
  const checkAndAutoSwitchSession = useCallback(() => {
    if (isWindowLive) return; // portions may still be sellable (or not yet counted)
    if (!selectedDate || !selectedSession || !hubLocalCutoffData) return;

    const now = new Date();

    // Date keys are derived from LOCAL calendar parts on both sides — deriving
    // "today" from getUTC*() here would put IST users on the previous day before 05:30.
    const todayKey = dateKey(normalizeToUTCMidnight(now));
    const selKey = dateKey(selectedDate);

    // Only auto-switch when viewing today
    if (todayKey !== selKey) return;

    // Use local cutoff check — instant, no API
    if (!isSessionPastCutoffLocal(selectedSession, now)) return;

    const target = resolveSessionSlot({
      session: selectedSession,
      availability: buildAvailabilityMap(allHubMenuData),
      hubData: hubLocalCutoffData,
      isEmployee: user?.status === "Employee",
      now,
      windowItems: windowItemsBySession,
    });

    // Nothing orderable for this session within the horizon — leave the selection
    // alone; DateSessionSelector shows "Serving Soon" for it.
    if (target.status !== "open") return;

    const switchKey = `${dateKey(target.dateObj)}|${selectedSession}`;
    if (autoSwitchInProgressRef.current === switchKey) return;
    autoSwitchInProgressRef.current = switchKey;

    setSelectedDate(target.dateObj);
    window.scrollTo(0, 0);
    if (effectiveHubId) {
      validateCutoffTiming(effectiveHubId, selectedSession, target.dateObj);
    }
  }, [
    isInWindow,
    isWindowLive,
    windowProductsLoading,
    windowItemsBySession,
    selectedDate,
    selectedSession,
    allHubMenuData,
    user?.status,
    hubLocalCutoffData,
    isSessionPastCutoffLocal,
    effectiveHubId,
    validateCutoffTiming,
  ]);

  const isOfferAlreadyAppliedInCart = (slotKey = null) => {
    if (!Carts || Carts.length === 0) return false;
    return Carts.some((item) => {
      if (slotKey) {
        const itemDateStr =
          item.deliveryDate?.split("T")[0] || item.deliveryDate;
        // const itemSlotKey = `${itemDateStr}|${item.session?.toLowerCase()}`;
        const itemSlotKey = `${itemDateStr}|${item.session}`;
        return (
          itemSlotKey === slotKey &&
          item.offerProduct === true &&
          item.offerApplied === true
        );
      }
      return item.offerProduct === true && item.offerApplied === true;
    });
  };

  // Count how many distinct date|session slots already have an offer applied in the cart
  const countOfferSlotsInCart = () => {
    if (!Carts || Carts.length === 0) return 0;
    const offerSlots = new Set();
    Carts.forEach((item) => {
      if (item.offerProduct === true && item.offerApplied === true) {
        const itemDateStr =
          item.deliveryDate?.split("T")[0] || item.deliveryDate;
        const slotKey = `${itemDateStr}|${(item.session || "").toLowerCase()}`;
        offerSlots.add(slotKey);
      }
    });
    return offerSlots.size;
  };

  const getAppliedOfferFromCart = (slotKey = null) => {
    if (!Carts || Carts.length === 0) return null;
    return Carts.find((item) => {
      if (slotKey) {
        const itemDateStr =
          item.deliveryDate?.split("T")[0] || item.deliveryDate;
        // const itemSlotKey = `${itemDateStr}|${item.session?.toLowerCase()}`;
        const itemSlotKey = `${itemDateStr}|${item.session?.toLowerCase()}`;
        return (
          itemSlotKey === slotKey &&
          item.offerProduct === true &&
          item.offerApplied === true
        );
      }
      return item.offerProduct === true && item.offerApplied === true;
    });
  };

  useEffect(() => {
    const checkCutoff = async () => {
      // Don't validate until hub data is loaded and auto-jump has settled.
      // This prevents the initial today+Lunch (cutoff passed) flash on refresh.
      if (!hubLocalCutoffData) return;
      if (autoJumpedHubRef.current !== effectiveHubId) return;

      if (effectiveHubId && selectedDate && selectedSession) {
        await validateCutoffTiming(
          effectiveHubId,
          selectedSession,
          selectedDate,
        );
      }
    };
    checkCutoff();
  }, [
    address,
    effectiveHubId,
    selectedDate,
    selectedSession,
    validateCutoffTiming,
    hubLocalCutoffData,
  ]);

  // Every second: local cutoff check — fires within 1s of cutoff, zero API calls
  useEffect(() => {
    checkAndAutoSwitchSession();
  }, [currentTime, checkAndAutoSwitchSession]);

  // ── Single cart-reconciliation pass ──────────────────────────────────────────
  // Judges every cart item by its OWN slot against the IST clock: regular items by
  // their ordering cutoff, window items by their own session's windowEnd. Runs on the
  // per-second tick reading the source-of-truth (localStorage), so items leave the
  // cart within ~1s of their deadline. It is NEVER keyed on the current selection, so
  // switching date/session can no longer remove anything. Replaces the old
  // cutoff-removal, window-close-transition, and hub-load window-scan effects.
  useEffect(() => {
    if (!hubLocalCutoffData?.cutoffTimes) return;
    const stored = JSON.parse(localStorage.getItem("cart") || "[]");
    const { updatedCart, cutoffRemoved, windowRemoved, changed } =
      reconcileCart(stored, hubLocalCutoffData, user?.status, currentTime);
    if (!changed) return;

    localStorage.setItem("cart", JSON.stringify(updatedCart));
    setCarts(updatedCart);

    if (cutoffRemoved.length > 0) {
      // Group removed items by slot for a clear message
      const slotMap = {};
      cutoffRemoved.forEach((item) => {
        const deliveryDate =
          typeof item.deliveryDate === "string"
            ? item.deliveryDate.split("T")[0]
            : item.deliveryDate;
        const session = String(item.session || "").toLowerCase();
        const key = `${deliveryDate}|${session}`;
        if (!slotMap[key]) slotMap[key] = { session, deliveryDate };
      });
      const slotLabels = Object.values(slotMap).map(
        ({ session, deliveryDate }) => {
          const d = new Date(deliveryDate + "T00:00:00");
          const day = d.toLocaleDateString("en-US", {
            weekday: "short",
            day: "numeric",
            month: "short",
          });
          return `${session.charAt(0).toUpperCase() + session.slice(1)}, ${day}`;
        },
      );

      fireToast({
        icon: cross,
        title: `${cutoffRemoved.length} item${cutoffRemoved.length > 1 ? "s" : ""} removed — ordering cutoff passed`,
        subtitle: slotLabels.join(" · "),
      });
    }

    if (windowRemoved.length > 0) {
      const totalUnits = windowRemoved.reduce(
        (s, i) => s + (i.quantity || 1),
        0,
      );
      fireToast({
        icon: cross,
        title: `${totalUnits} window portion${totalUnits > 1 ? "s" : ""} removed — window has closed`,
      });
    }
  }, [currentTime, hubLocalCutoffData, user?.status]); // eslint-disable-line react-hooks/exhaustive-deps

  // Persistent socket for window qty real-time updates — one per Home lifetime
  useEffect(() => {
    const socket = io("https://dailydish.in");
    socketRef.current = socket;
    socket.on(
      "window_qty_update",
      ({
        productId,
        hubId: eventHubId,
        windowRemainingQuantity,
        windowTotalQuantity,
        isActive,
      }) => {
        const pid = String(productId);

        // The event names the pool it came from: null = the shared global pool, an id
        // = that hub's private pool. We must only apply events for the pool THIS user
        // is drawing from, or a sale in another hub would rewrite the stock shown
        // here. Each window product carries the hubId of the row it resolved to.
        // (A backend that predates hubId sends undefined, which normalises to null
        // and matches the global row — so this stays correct during deploy skew.)
        const shown = windowProductsRef.current.find(
          (p) => String(p.productId?._id || p.productId) === pid,
        );
        if (!shown) return;
        const ourPool = shown.hubId == null ? null : String(shown.hubId);
        const eventPool = eventHubId == null ? null : String(eventHubId);
        if (ourPool !== eventPool) return;

        setWindowQtyMap((prev) => ({
          ...prev,
          [pid]: windowRemainingQuantity,
        }));
        // Reflect admin changes to totalQty or isActive in the products list
        if (windowTotalQuantity !== undefined || isActive !== undefined) {
          setWindowProducts((prev) =>
            prev
              .map((p) => {
                if (String(p.productId?._id || p.productId) !== pid) return p;
                return {
                  ...p,
                  ...(windowTotalQuantity !== undefined && {
                    windowTotalQuantity,
                  }),
                  ...(windowRemainingQuantity !== undefined && {
                    windowRemainingQuantity,
                  }),
                  ...(isActive !== undefined && { isActive }),
                };
              })
              .filter((p) => p.isActive !== false),
          );
        }
      },
    );
    return () => {
      socket.disconnect();
      socketRef.current = null;
    };
  }, []);

  // Which sessions have a live window right now. Changes only when a window opens or
  // closes, so it does not churn on the per-second clock tick.
  const openWindowSessions = useMemo(
    () =>
      SESSION_ORDER.filter((s) =>
        isWindowOpen(s, currentTime, hubLocalCutoffData),
      ).join(","),
    [currentTime, hubLocalCutoffData],
  );

  // Prefetch every open window as soon as hub data lands — in parallel with the menu,
  // not on click. Clicking a window session then paints from cache, as instantly as
  // breakfast/dinner paint from allHubMenuData. It also gives us a portions-left count
  // for EVERY session, so unselected cards stop advertising an empty window.
  useEffect(() => {
    if (!effectiveHubId || !hubLocalCutoffData) return;
    const sessions = openWindowSessions ? openWindowSessions.split(",") : [];
    if (!sessions.length) {
      setWindowCounts({});
      return;
    }

    let cancelled = false;
    const todayKey = dateKey(normalizeToUTCMidnight(new Date()));

    Promise.all(
      sessions.map((session) =>
        axios
          .get("https://dailydish.in/api/user/instant-window/status", {
            params: {
              hubId: effectiveHubId,
              session,
              menuDate: todayKey,
            },
          })
          .then((res) => ({
            session,
            products: res.data?.windowProducts || [],
          }))
          .catch(() => ({ session, products: [] })),
      ),
    ).then((results) => {
      if (cancelled) return;
      const counts = {};
      results.forEach(({ session, products }) => {
        windowCacheRef.current[`${session}|${todayKey}`] = products;
        counts[session.toLowerCase()] = products.filter(
          (p) => Number(p.windowRemainingQuantity) > 0,
        ).length;
      });
      setWindowCounts(counts);
    });

    return () => {
      cancelled = true;
    };
  }, [effectiveHubId, hubLocalCutoffData, openWindowSessions]);

  // Show the window products for the current selection. Served from the prefetch cache
  // when we have it (no spinner, no request); only an uncached window hits the network.
  useEffect(() => {
    if (!isInWindow || !effectiveHubId || !selectedSession) {
      if (!isInWindow) {
        setWindowProducts([]);
        setWindowQtyMap({});
        setWindowFetchKey(null);
      }
      return;
    }

    const fetchKey = `${selectedSession}|${selectedDateKey}`;
    const applyProducts = (products) => {
      setWindowProducts(products);
      const map = {};
      products.forEach((p) => {
        const pid = String(p.productId?._id || p.productId);
        map[pid] = p.windowRemainingQuantity;
      });
      setWindowQtyMap((prev) => ({ ...prev, ...map }));
      setWindowFetchKey(fetchKey);
    };

    const cached = windowCacheRef.current[fetchKey];
    if (cached) {
      // The qty socket keeps these live, so a cache hit needs no revalidation.
      applyProducts(cached);
      setWindowProductsLoading(false);
      return;
    }

    let cancelled = false;
    setWindowFetchKey(null); // the products in state are not this selection's — yet
    setWindowProductsLoading(true);
    axios
      .get("https://dailydish.in/api/user/instant-window/status", {
        params: {
          hubId: effectiveHubId,
          session: selectedSession,
          menuDate: selectedDateKey,
        },
      })
      .then((res) => {
        if (cancelled) return;
        const products = res.data?.windowProducts || [];
        windowCacheRef.current[fetchKey] = products;
        applyProducts(products);
      })
      .catch(console.error)
      .finally(() => {
        if (!cancelled) setWindowProductsLoading(false);
      });
    return () => {
      cancelled = true;
    };
    // Keyed on the date STRING, not the Date object: anything that re-creates an
    // equal Date would otherwise refetch and leave windowProductsLoading pinned true.
  }, [isInWindow, effectiveHubId, selectedSession, selectedDateKey]);

  // Window-item removal (real-time close, page refresh, SPA re-mount, past-date) is
  // handled by the unified reconcileCart pass above — it checks each window item
  // against its own session's windowEnd on every tick, so no separate effect is needed.
  // prevIsInWindowRef is still updated here so any future close-transition consumer
  // keeps working, but it no longer drives cart removal.
  useEffect(() => {
    prevIsInWindowRef.current = isInWindow;
  }, [isInWindow]);

  // NOTE: an effect used to live here that force-snapped selectedDate back to TODAY,
  // every clock tick, whenever the selected session's window was open. It made it
  // impossible to leave today while any window was running: tapping a "Tomorrow" card
  // was undone within a second, the cutoff auto-switch was dragged back, and because it
  // re-created the Date object each tick it retriggered the window fetch forever, so
  // windowProductsLoading never settled. Pulling the user to today is now the card's
  // job — an open window with portions left resolves to today and surfaces the
  // "← Back to today's <session>" row, which the user chooses to take.

  // When menu data loads, immediately jump to the next available date/session.
  // Only jumps if the current selection has no valid menu (e.g. no menu for tomorrow,
  // but menu exists for day-after-tomorrow). Does NOT override user's manual selection.
  const selectedDateRef = useRef(selectedDate);
  const selectedSessionRef = useRef(selectedSession);
  // Tracks the last key we auto-jumped to — prevents re-firing when deps change but result is the same
  const autoJumpedToRef = useRef(null);
  // Tracks which hub the last auto-jump was for — forces re-jump on hub change
  const autoJumpedHubRef = useRef(null);
  useEffect(() => {
    selectedDateRef.current = selectedDate;
  }, [selectedDate]);
  useEffect(() => {
    selectedSessionRef.current = selectedSession;
  }, [selectedSession]);

  useEffect(() => {
    if (!allHubMenuData?.length) return;
    // Wait for hub cutoff data before auto-jumping — without it we don't know
    // the orderMode, which determines whether today is a valid start date.
    // This prevents the today→tomorrow→today flicker on instant-mode hubs.
    if (!hubLocalCutoffData) return;

    const now = new Date();
    const isEmployee = user?.status === "Employee";
    const availability = buildAvailabilityMap(allHubMenuData);
    const todayKey = dateKey(normalizeToUTCMidnight(now));

    // Check if current selection is already valid — if so, don't override
    // BUT always re-jump if the hub changed (different orderMode may apply)
    const hubChanged = autoJumpedHubRef.current !== effectiveHubId;
    const curDate = selectedDateRef.current;
    const curSession = selectedSessionRef.current;
    if (!hubChanged && curDate && curSession) {
      if (hasMenu(availability, curDate, curSession)) {
        const slot = resolveSessionSlot({
          session: curSession,
          availability,
          hubData: hubLocalCutoffData,
          isEmployee,
          now,
          windowItems: windowItemsBySession,
        });

        // Valid when the selection sits on the slot this session resolves to — which
        // includes today during a live window (a raw past-cutoff test would call that
        // invalid and bounce the user to the next day mid-window) — or on any later date
        // the user deliberately browsed to via a card / the "see <day>'s menu" row.
        const onResolvedSlot =
          slot.status !== "none" && dateKey(slot.dateObj) === dateKey(curDate);
        const browsingAhead = dateKey(curDate) > todayKey;

        if (onResolvedSlot || browsingAhead) {
          autoJumpedHubRef.current = effectiveHubId; // mark settled even when no jump needed
          setHubSettled(true);
          return; // Valid selection, leave it alone
        }
      }
    }

    // Current selection is invalid — land on the soonest slot the user can actually
    // order: earliest date, and within that date the earliest session in serving order.
    let best = null;
    SESSION_ORDER.forEach((session) => {
      const slot = resolveSessionSlot({
        session,
        availability,
        hubData: hubLocalCutoffData,
        isEmployee,
        now,
        windowItems: windowItemsBySession,
      });
      if (slot.status === "none") return;
      if (!best || slot.dateObj < best.dateObj) {
        best = { session, dateObj: slot.dateObj };
      }
    });

    if (!best) return; // nothing orderable anywhere — selector shows the empty state

    const jumpKey = `${dateKey(best.dateObj)}|${best.session}`;
    if (autoJumpedToRef.current === jumpKey && !hubChanged) return; // already jumped here for this hub
    autoJumpedToRef.current = jumpKey;
    autoJumpedHubRef.current = effectiveHubId;
    setHubSettled(true);
    setSelectedDate(best.dateObj);
    setSelectedSession(best.session);
    if (effectiveHubId) {
      validateCutoffTiming(effectiveHubId, best.session, best.dateObj);
    }
  }, [
    allHubMenuData,
    hubLocalCutoffData,
    isSessionPastCutoffLocal,
    effectiveHubId,
    validateCutoffTiming,
    user?.status,
    windowItemsBySession,
  ]);

  // NOTE: cutoff re-validation on a timer is intentionally removed.
  // validateCutoffTiming is already called whenever selectedDate/selectedSession changes,
  // and CutoffTimer manages its own countdown internally.

  const refreshAddress = useCallback(() => {
    try {
      const primaryAddress = localStorage.getItem("primaryAddress");
      const currentLocation = localStorage.getItem("currentLocation");
      const defaultHubData = localStorage.getItem("defaultHubData");
      if (primaryAddress && primaryAddress !== "null") {
        const parsedPrimary = JSON.parse(primaryAddress);
        setAddress(parsedPrimary);
        setShouldLoadDefaultMenu(false);
      } else if (currentLocation && currentLocation !== "null") {
        const parsedCurrent = JSON.parse(currentLocation);
        setAddress(parsedCurrent);
        setShouldLoadDefaultMenu(false);
      } else if (defaultHubData && defaultHubData !== "null") {
        try {
          const parsedDefault = JSON.parse(defaultHubData);
          const defaultAddress = {
            hubId:
              parsedDefault.hubId ||
              parsedDefault._id ||
              // "69f969b4b9bf9539ada9550d", //test hub id
              "6a4b63c1f3fdb51880c636b4",
            hubName:
              parsedDefault.hubName || parsedDefault.name || "Default Hub",
            fullAddress:
              parsedDefault.address || "Select your location to view menu",
            isDefaultHub: true,
            location: parsedDefault.location || {
              type: "Point",
              coordinates: [0, 0],
            },
          };
          setAddress(defaultAddress);
          setShouldLoadDefaultMenu(false);
          localStorage.setItem(
            "currentLocation",
            JSON.stringify(defaultAddress),
          );
        } catch (e) {
          console.error("Error parsing default hub data:", e);
          setAddress(null);
          setShouldLoadDefaultMenu(!user);
        }
      } else {
        setAddress(null);
        setShouldLoadDefaultMenu(!user);
      }
    } catch (error) {
      console.error("Error refreshing address:", error);
      setAddress(null);
      setShouldLoadDefaultMenu(!user);
    }
  }, [user]);

  // Combined hub data + menu fetch — runs once per hub change, sets both atomically
  // so the auto-jump logic always has both pieces of data at the same time (no flicker).
  useEffect(() => {
    const hubIdToUse = effectiveHubId;

    if (!hubIdToUse) {
      setAllHubMenuData([]);
      setMenuHubId(null);
      setHubLocalCutoffData(null);
      setloader(false);
      return;
    }

    // A cached copy of THIS hub's data (from a previous mount) is already on screen —
    // revalidate it in the background rather than blanking the page and spinning.
    const cached = getCachedHubData(hubIdToUse);

    // Reset auto-jump guard so the new hub gets a fresh auto-jump
    autoJumpedToRef.current = null;
    autoJumpedHubRef.current = null;

    if (!cached) {
      // Mark hub as not yet settled — hides the "Orders Closed" card until auto-jump completes
      setHubSettled(false);
      // Clear stale cutoff data immediately so the auto-jump gate waits for fresh data
      setHubLocalCutoffData(null);
      // Clear stale cutoffValidation so CutoffStatusCard stays hidden until new data arrives
      setCutoffValidation({
        allowed: true,
        message: "",
        cutoffDateTime: null,
        nextAvailableDateTime: null,
        orderMode: "preorder",
      });
    } else {
      // Make sure state matches the cache even if this mount started on another hub
      setAllHubMenuData(cached.menu);
      setMenuHubId(hubIdToUse);
      setHubLocalCutoffData(cached.cutoff);
    }

    const fetchHubDataAndMenu = async () => {
      if (!cached) setloader(true);
      try {
        const token = localStorage.getItem("authToken");

        // Fetch both in parallel
        const [menuRes, cutoffRes] = await Promise.allSettled([
          axios.get("https://dailydish.in/api/user/get-hub-menu", {
            params: { hubId: hubIdToUse },
          }),
          fetch(`https://dailydish.in/api/Hub/get-cutoff-times/${hubIdToUse}`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        // Process menu
        let freshMenu = null;
        let freshCutoff = null;

        if (menuRes.status === "fulfilled" && menuRes.value.status === 200) {
          const menuData = menuRes.value.data.menu;
          freshMenu = menuData;
          // Debug: log offer items received from backend
          const offerItems = menuData.filter((m) => m.isOffer);
          // console.log("[OFFER DEBUG] Menu loaded. Total items:", menuData.length, "Offer items:", offerItems.length);
          // if (offerItems.length > 0) {
          //   console.log("[OFFER DEBUG] Offer items from backend:", offerItems.map(m => ({
          //     foodname: m.foodname,
          //     isOffer: m.isOffer,
          //     offerPrice: m.offerPrice,
          //     offerStartDate: m.offerStartDate,
          //     offerEndDate: m.offerEndDate,
          //     customerType: m.customerType,
          //     deliveryDate: m.deliveryDate,
          //     hubId: m.hubId,
          //   })));
          // } else {
          //   console.log("[OFFER DEBUG] ⚠️ No offer items in menu response. Sample item:", menuData[0]);
          // }
          setAllHubMenuData(menuData);
          setMenuHubId(hubIdToUse);
        } else if (!cached) {
          setAllHubMenuData([]);
          setMenuHubId(hubIdToUse);
        }

        // Process cutoff data
        if (cutoffRes.status === "fulfilled" && cutoffRes.value.ok) {
          const data = await cutoffRes.value.json();
          const cutoffTimes = data.cutoffTimes || {};
          const orderMode = data.orderMode || "preorder";
          // employeeCutoff is used exactly as the backend sends it — when absent,
          // employees fall back to the session's defaultCutoff (no invented time).
          ["breakfast", "lunch", "dinner"].forEach((s) => {
            if (!cutoffTimes[s]) cutoffTimes[s] = {};
            if (!cutoffTimes[s].defaultCutoff)
              cutoffTimes[s].defaultCutoff =
                orderMode === "instant" ? "20:00" : "23:59";
          });
          // hubId ("HUB005") and hubType ride along so the cutoff card can pick
          // the right delivery windows — a school serves lunch earlier than a
          // residential hub. hubType is not sent by the API yet; keeping it here
          // means it starts working the day the backend adds it, with no
          // frontend change.
          freshCutoff = {
            orderMode,
            cutoffTimes,
            hubId: data.hubId || null,
            hubType: data.hubType || null,
          };
          // Set both in the same tick so auto-jump fires once with complete data
          setHubLocalCutoffData(freshCutoff);
        } else if (!cached) {
          setHubLocalCutoffData({
            orderMode: "preorder",
            cutoffTimes: {
              breakfast: { defaultCutoff: "23:59" },
              lunch: { defaultCutoff: "23:59" },
              dinner: { defaultCutoff: "23:59" },
            },
          });
        }

        // Cache whatever came back so the next mount (e.g. back from /checkout) paints
        // from memory instead of blocking on this round-trip again.
        if (freshMenu || freshCutoff) {
          setCachedHubData(hubIdToUse, {
            menu: freshMenu ?? cached?.menu ?? [],
            cutoff: freshCutoff ?? cached?.cutoff ?? null,
          });
        }
      } catch (error) {
        console.error("Error fetching hub data:", error);
        // A failed background revalidate must not wipe the copy already on screen.
        if (!cached) {
          setAllHubMenuData([]);
          setMenuHubId(hubIdToUse);
        }
      } finally {
        setloader(false);
      }
    };

    fetchHubDataAndMenu();
  }, [effectiveHubId]);

  // Admin cutoff changes don't reach an already-open tab — the hub fetch above runs
  // only on mount / hub change. Refetch the cutoff when the tab regains focus or
  // becomes visible again, so a customer returning to the tab picks up the current
  // cutoff. Frontend-only, throttled; the per-second reconcile + auto-switch effects
  // then apply it (window opens/closes, stale cart items drop) with no extra wiring.
  useEffect(() => {
    const hubId = effectiveHubId;
    if (!hubId) return;

    let inFlight = false;
    let lastFetchedAt = 0;

    const refetchCutoff = async () => {
      if (inFlight || document.visibilityState === "hidden") return;
      const nowTs = Date.now();
      if (nowTs - lastFetchedAt < 8000) return; // throttle rapid focus/visibility toggles
      lastFetchedAt = nowTs;
      inFlight = true;
      try {
        const token = localStorage.getItem("authToken");
        const res = await fetch(
          `https://dailydish.in/api/Hub/get-cutoff-times/${hubId}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );
        if (!res.ok) return;
        const data = await res.json();
        const cutoffTimes = data.cutoffTimes || {};
        const orderMode = data.orderMode || "preorder";
        // Same defaultCutoff backfill the initial fetch applies, so the shape matches.
        ["breakfast", "lunch", "dinner"].forEach((s) => {
          if (!cutoffTimes[s]) cutoffTimes[s] = {};
          if (!cutoffTimes[s].defaultCutoff)
            cutoffTimes[s].defaultCutoff =
              orderMode === "instant" ? "20:00" : "23:59";
        });
        const freshCutoff = { orderMode, cutoffTimes };
        setHubLocalCutoffData(freshCutoff);
        setHubOrderMode(orderMode);
        // Keep the module cache in sync so a later remount paints the fresh cutoff.
        const cached = getCachedHubData(hubId);
        setCachedHubData(hubId, {
          menu: cached?.menu ?? [],
          cutoff: freshCutoff,
        });
        // Re-validate the current selection against the refreshed cutoff.
        const d = selectedDateRef.current;
        const s = selectedSessionRef.current;
        if (d && s) validateCutoffTiming(hubId, s, d);
      } catch {
        // A failed refetch just leaves the current cutoff in place.
      } finally {
        inFlight = false;
      }
    };

    const onVisibility = () => {
      if (document.visibilityState === "visible") refetchCutoff();
    };
    window.addEventListener("focus", refetchCutoff);
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      window.removeEventListener("focus", refetchCutoff);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [effectiveHubId, validateCutoffTiming]);

  // Listen for location updates
  useEffect(() => {
    const handleLocationUpdated = () => refreshAddress();
    const handleAddressUpdated = () => refreshAddress();
    const handleAddressAdded = () => refreshAddress();
    const handleFocus = () => refreshAddress();
    const handleDefaultHubLoaded = () => refreshAddress();
    const handleStorageChange = (e) => {
      if (
        e.key === "currentLocation" ||
        e.key === "primaryAddress" ||
        e.key === "defaultHubData"
      ) {
        refreshAddress();
      }
    };

    window.addEventListener("locationUpdated", handleLocationUpdated);
    window.addEventListener("addressUpdated", handleAddressUpdated);
    window.addEventListener("addressAdded", handleAddressAdded);
    window.addEventListener("focus", handleFocus);
    window.addEventListener("defaultHubLoaded", handleDefaultHubLoaded);
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("locationUpdated", handleLocationUpdated);
      window.removeEventListener("addressUpdated", handleAddressUpdated);
      window.removeEventListener("addressAdded", handleAddressAdded);
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("defaultHubLoaded", handleDefaultHubLoaded);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [refreshAddress]);

  const handleSelectionChange = (date1, session1) => {
    // Re-arm the auto-switch: a manual pick may land on a slot that later closes,
    // and the one-shot guard would otherwise swallow that switch.
    autoSwitchInProgressRef.current = null;
    setSelectedDate(date1);
    setSelectedSession(session1);
    window.scrollTo(0, 0);

    // Immediately validate cutoff for the new selection
    if (effectiveHubId && date1 && session1) {
      validateCutoffTiming(effectiveHubId, session1, date1);
    }
  };

  const handleLocationDetected = useCallback((newLocation) => {
    setAddress(newLocation);
    setShouldLoadDefaultMenu(false);
    if (newLocation) {
      localStorage.setItem("currentLocation", JSON.stringify(newLocation));
    }
    window.dispatchEvent(new Event("locationUpdated"));
  }, []);

  // Build a preliminary cutoffValidation from local hub cutoff data so CutoffStatusCard
  // can render as soon as the menu loads — without waiting for the validate-order-timing
  // API call to complete. Once the real API response arrives, cutoffValidation takes over.
  // The API cutoff result is stamped with the session+date it was fetched for. On a
  // session/date switch the previous result lingers for the ~1s the new validate call
  // is in flight — treat that as stale so the card falls back to the instant local
  // value instead of showing the previous slot's "Order by" time.
  const apiCutoffFresh = useMemo(() => {
    if (!cutoffValidation?.cutoffDateTime) return false;
    const selSession = selectedSession?.toLowerCase();
    const selDateStr = selectedDate
      ? new Date(selectedDate).toISOString().split("T")[0]
      : null;
    return (
      cutoffValidation._forSession === selSession &&
      cutoffValidation._forDate === selDateStr
    );
  }, [cutoffValidation, selectedSession, selectedDate]);

  const preliminaryCutoffValidation = useMemo(() => {
    // Trust the API value only when it was fetched for the CURRENT selection.
    if (apiCutoffFresh) return cutoffValidation;
    // Need local cutoff data and a selected session to compute anything
    if (!hubLocalCutoffData?.cutoffTimes || !selectedSession || !selectedDate)
      return null;

    const key = selectedSession.toLowerCase();
    const times = hubLocalCutoffData.cutoffTimes[key];
    if (!times) return null;

    const cutoffStr = getCutoff(
      selectedSession,
      hubLocalCutoffData,
      user?.status === "Employee",
    );
    if (!cutoffStr) return null;

    const [h, m] = cutoffStr.split(":").map(Number);
    // Build cutoff datetime for the selected date at the local cutoff time
    const cutoffDate = new Date(selectedDate);
    cutoffDate.setHours(h, m, 0, 0);

    const now = new Date();
    const allowed = now < cutoffDate;
    const orderMode = hubLocalCutoffData.orderMode || "preorder";

    return {
      allowed,
      message: allowed ? "" : `Orders closed for ${selectedSession}`,
      cutoffDateTime: cutoffDate,
      nextAvailableDateTime: null,
      orderMode,
      _forSession: key,
      _forDate: selectedDate.toISOString().split("T")[0],
      _isPreliminary: true,
    };
  }, [
    apiCutoffFresh,
    cutoffValidation,
    hubLocalCutoffData,
    selectedSession,
    selectedDate,
    user?.status,
  ]);

  // The effective cutoff to pass to CutoffStatusCard — the API result when it matches
  // the current selection, the instant local preliminary otherwise (fresh load, or the
  // brief in-flight moment right after a session/date switch).
  const effectiveCutoffValidation = apiCutoffFresh
    ? cutoffValidation
    : preliminaryCutoffValidation;

  // Use preliminary local-data cutoff as initial answer so the menu never flashes
  // wrong content on refresh. The real API result overrides once it arrives.
  // Note: preliminary uses local clock comparison which is accurate on IST machines;
  // the API result is always trusted over preliminary when available.
  const isOrderingAllowed = useMemo(() => {
    if (apiCutoffFresh) return cutoffValidation.allowed;
    if (preliminaryCutoffValidation?.cutoffDateTime)
      return preliminaryCutoffValidation.allowed;
    return true;
  }, [apiCutoffFresh, cutoffValidation, preliminaryCutoffValidation]);

  const currentSlotItems = useMemo(() => {
    if (!allHubMenuData?.length) return [];
    // Wait for auto-jump to finalize the correct date/session before rendering items.
    // Without this gate, the default today/Lunch selection flashes its items briefly
    // before the auto-jump switches to tomorrow.
    if (!hubSettled) return [];

    if (!isOrderingAllowed && isViewingToday) {
      return [];
    }

    // Match using UTC date comparison to handle timezone differences
    const selUTCKey = `${selectedDate.getUTCFullYear()}-${String(selectedDate.getUTCMonth() + 1).padStart(2, "0")}-${String(selectedDate.getUTCDate()).padStart(2, "0")}`;
    return allHubMenuData.filter((item) => {
      if (!item.deliveryDate) return false;
      // Case-insensitive session match to handle "Lunch" vs "lunch"
      if (item.session?.toLowerCase() !== selectedSession?.toLowerCase())
        return false;
      const d = new Date(item.deliveryDate);
      const itemKey = `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}-${String(d.getUTCDate()).padStart(2, "0")}`;
      return itemKey === selUTCKey;
    });
  }, [
    allHubMenuData,
    selectedDate,
    selectedSession,
    isOrderingAllowed,
    hubSettled,
    isViewingToday,
  ]);

  const vegFilteredItems = useMemo(() => {
    if (isVegOnly) {
      return currentSlotItems.filter((item) => item.foodcategory === "Veg");
    }
    return currentSlotItems;
  }, [currentSlotItems, isVegOnly]);

  // Admin maintains exactly two categories. Matching is case/space-insensitive so a
  // stray "combos" or "Build your meal" from the admin form can't blank the grid.
  const normalizeCategory = (c) =>
    String(c || "")
      .trim()
      .toLowerCase();

  // The main grid: the "Build Your Meal" category only. Anything uncategorised is
  // included too, so a row the admin forgot to tag still reaches the customer
  // instead of silently disappearing.
  const finalDisplayItems = useMemo(
    () =>
      vegFilteredItems.filter((item) => {
        const cat = normalizeCategory(item.menuCategory);
        return cat !== "combos";
      }),
    [vegFilteredItems],
  );

  // Combos never appear in the grid — they are reached through the Customise card.
  const comboItems = useMemo(
    () =>
      vegFilteredItems.filter(
        (item) => normalizeCategory(item.menuCategory) === "combos",
      ),
    [vegFilteredItems],
  );

  // Close the combos modal if the slot changes out from under it (session switch,
  // cutoff auto-switch) and the new slot has no combos to show.
  useEffect(() => {
    if (showCombosModal && comboItems.length === 0) setShowCombosModal(false);
  }, [comboItems.length, showCombosModal]);

  const getEffectivePrice = (item, matchedLocation, session) => {
    const hubPrice =
      (matchedLocation &&
        (matchedLocation.hubPrice || matchedLocation.basePrice)) ||
      item?.hubPrice ||
      item?.basePrice ||
      0;
    const preOrderPrice =
      (matchedLocation &&
        (matchedLocation.preOrderPrice || matchedLocation.preorderPrice)) ||
      item?.preOrderPrice ||
      item?.preorderPrice ||
      0;
    if (hubOrderMode === "instant") {
      return { price: hubPrice };
    }
    const beforeCutoff = isOrderingAllowed;
    if (beforeCutoff && preOrderPrice > 0) return { price: preOrderPrice };
    return { price: hubPrice };
  };

  const [cartCount, setCartCount] = useState(0);
  const [isCartVisible, setIsCartVisible] = useState(false);
  const handleShow = () => {
    setCartCount(cartCount + 1);
    setIsCartVisible(true);
  };

  const [foodData, setFoodData] = useState({});
  const [open, setOpen] = useState(false);
  const showDrawer = (food) => {
    setFoodData(food);
    setOpen(true);
  };
  const onClose = () => setOpen(false);

  useEffect(() => {
    if (open) {
      document.body.classList.add("drawer-open");
    } else {
      document.body.classList.remove("drawer-open");
    }
    return () => document.body.classList.remove("drawer-open");
  }, [open]);

  useEffect(() => {
    refreshAddress();
  }, [user]);

  const getProductOffer = (item) => {
    try {
      // Rule 1: Employees never get offers
      if (user?.status === "Employee") return null;

      // Rule 2: Item must be flagged as offer in HubMenu
      if (!item?.isOffer || !item?.offerPrice) {
        // Only log for items that have isOffer set to see what's happening
        if (item?.isOffer)
          console.log(
            "[OFFER DEBUG] Rule2 fail - isOffer:",
            item?.isOffer,
            "offerPrice:",
            item?.offerPrice,
            "item:",
            item?.foodname,
          );
        return null;
      }

      // console.log("[OFFER DEBUG] Checking offer for:", item?.foodname, {
      //   isOffer: item.isOffer,
      //   offerPrice: item.offerPrice,
      //   offerStartDate: item.offerStartDate,
      //   offerEndDate: item.offerEndDate,
      //   customerType: item.customerType,
      //   deliveryDate: item.deliveryDate,
      //   menuDate: item.menuDate,
      //   hubId: item.hubId,
      // });

      // Rule 3: Must be within offer date range (compare date strings only — ignore time component)
      const deliveryDateStr = (item.deliveryDate || item.menuDate || "")
        .toString()
        .split("T")[0];
      if (!deliveryDateStr) {
        console.log("[OFFER DEBUG] Rule3 fail - no deliveryDateStr");
        return null;
      }
      // If no date range is set, the offer is always valid date-wise
      if (item.offerStartDate) {
        const startStr = new Date(item.offerStartDate)
          .toISOString()
          .split("T")[0];
        if (deliveryDateStr < startStr) {
          console.log(
            "[OFFER DEBUG] Rule3 fail - before start:",
            deliveryDateStr,
            "<",
            startStr,
          );
          return null;
        }
      }
      if (item.offerEndDate) {
        const endStr = new Date(item.offerEndDate).toISOString().split("T")[0];
        if (deliveryDateStr > endStr) {
          console.log(
            "[OFFER DEBUG] Rule3 fail - after end:",
            deliveryDateStr,
            ">",
            endStr,
          );
          return null;
        }
      }

      // Rule 4: Customer type eligibility (skip for non-logged-in — show offer to entice login)
      const orderCount = userOrderCount;
      const customerType = item.customerType ?? -1;
      if (user && customerType !== -1) {
        if (customerType === 0 && orderCount !== 0) {
          console.log(
            "[OFFER DEBUG] Rule4 fail - customerType=0 but orderCount:",
            orderCount,
          );
          return null;
        }
        if (customerType > 0 && orderCount > customerType) {
          console.log(
            "[OFFER DEBUG] Rule4 fail - orderCount",
            orderCount,
            "> customerType",
            customerType,
          );
          return null;
        }
      }

      // Rule 5: Check if user has exhausted their offer slot budget
      // Skip for non-logged-in users — show offer price to entice them
      if (user) {
        const maxAllowed = customerType === -1 ? Infinity : customerType + 1;
        const usedInPast = userOfferStatus.usedOfferCount;
        const usedInCart = countOfferSlotsInCart();
        const remaining = maxAllowed - usedInPast - usedInCart;
        // console.log("[OFFER DEBUG] Rule5 - maxAllowed:", maxAllowed, "usedInPast:", usedInPast, "usedInCart:", usedInCart, "remaining:", remaining);
        if (remaining <= 0) {
          console.log("[OFFER DEBUG] Rule5 fail - no remaining slots");
          return null;
        }
      }

      // Rule 6: Cross-hub + same-session block (logged-in only)
      const dateStr = deliveryDateStr;
      if (user) {
        const itemHubId = item.hubId?.toString();
        const slotKey = `${dateStr}|${selectedSession.toLowerCase()}|${itemHubId}`;
        const slotAlreadyUsed = userOfferStatus.usedSlots.includes(slotKey);
        // console.log("[OFFER DEBUG] Rule6 - slotKey:", slotKey, "usedSlots:", userOfferStatus.usedSlots, "alreadyUsed:", slotAlreadyUsed);
        if (slotAlreadyUsed) {
          console.log("[OFFER DEBUG] Rule6 fail - slot already used");
          return null;
        }
      }

      // Rule 7: One offer per date|session slot in cart (logged-in only)
      const cartSlotKey = `${dateStr}|${selectedSession.toLowerCase()}`;
      if (user) {
        const hasOfferInCart = isOfferAlreadyAppliedInCart(cartSlotKey);
        if (hasOfferInCart) {
          // console.log("[OFFER DEBUG] Rule7 - offer already in cart, returning isBlocked");
          return { ...item, isBlocked: true };
        }
      }

      // console.log("[OFFER DEBUG] ✅ Offer ELIGIBLE for:", item?.foodname);
      return item; // eligible
    } catch (error) {
      console.error("Error getting product offer:", error);
      return null;
    }
  };

  const [deliveryCharge, setDeliveryCharge] = useState([]);
  const getDeliveryRates = async () => {
    try {
      const res = await axios.get("https://dailydish.in/api/deliveryrate/all");
      setDeliveryCharge(res.data.data);
    } catch (error) {
      console.error("Error fetching delivery rates:", error);
    }
  };

  useEffect(() => {
    getDeliveryRates();
  }, []);

  const findDeliveryRate = (hubId, status) => {
    if (!deliveryCharge || deliveryCharge.length === 0) return 0;
    // Match by hubId + status, fall back to any record for this hub
    const matchedRate =
      deliveryCharge.find(
        (rate) =>
          String(rate.hubId) === String(hubId) && rate.status === status,
      ) || deliveryCharge.find((rate) => String(rate.hubId) === String(hubId));
    // Use doorDeliveryRate — the base charge stored on cart items
    return Number(matchedRate?.doorDeliveryRate) || 0;
  };

  // Returns the full matched delivery rate record for the current hub+status
  const findDeliveryRateRecord = (hubId, status) => {
    if (!deliveryCharge || deliveryCharge.length === 0) return null;
    return (
      deliveryCharge.find(
        (rate) =>
          String(rate.hubId) === String(hubId) && rate.status === status,
      ) ||
      deliveryCharge.find((rate) => String(rate.hubId) === String(hubId)) ||
      null
    );
  };

  const isEmployeeForDelivery = user?.status === "Employee";
  const userStatus = user?.status;
  const hubId = address?.hubId;
  const deliveryRate = findDeliveryRate(
    hubId,
    isEmployeeForDelivery ? "Employee" : "Normal",
  );

  const triggerConfetti = () => {
    const duration = 2000;
    const animationEnd = Date.now() + duration;
    const defaults = {
      startVelocity: 30,
      spread: 360,
      ticks: 60,
      zIndex: 99999,
    };

    function randomInRange(min, max) {
      return Math.random() * (max - min) + min;
    }

    const interval = setInterval(function () {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 50 * (timeLeft / duration);

      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
      });
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
      });
    }, 250);
  };

  const addCart1 = async (item, offerData, matchedLocation) => {
    if (!user) {
      fireToast({ title: `Login to continue` });
      return;
    }

    if (!isOrderingAllowed) {
      fireToast({
        title:
          cutoffValidation.message ||
          `Cannot add to cart. Orders are closed for ${selectedSession}.`,
      });
      return;
    }

    if (!matchedLocation || matchedLocation?.Remainingstock === 0) {
      fireToast({ title: `Product is out of stock` });
      return;
    }

    const dateStr =
      selectedDate instanceof Date
        ? selectedDate.toISOString().split("T")[0]
        : new Date(selectedDate).toISOString().split("T")[0];
    const slotKey = `${dateStr}|${selectedSession.toLowerCase()}`;
    const hasOfferInCart = isOfferAlreadyAppliedInCart(slotKey);
    const appliedOffer = getAppliedOfferFromCart(slotKey);
    const regularPrice =
      matchedLocation?.hubPrice ||
      item?.hubPrice ||
      matchedLocation?.basePrice ||
      item?.basePrice ||
      115;

    let appliedPrice;
    let isOfferApplied = false;
    let finalOfferPrice = null;
    let finalRegularPrice = regularPrice;

    // New offer management: read offer data directly from HubMenu item
    if (user?.status === "Employee") {
      // Employees never get offer price
      appliedPrice = regularPrice;
    } else if (offerData && offerData.offerPrice && user?._id) {
      const itemHubId =
        matchedLocation?.hubId?.toString() || item?.hubId?.toString();
      const slotKey = `${dateStr}|${selectedSession.toLowerCase()}|${itemHubId}`;
      const cartSlotKey = `${dateStr}|${selectedSession.toLowerCase()}`;

      const slotAlreadyUsed = userOfferStatus.usedSlots.includes(slotKey);
      const customerType = offerData.customerType ?? -1;
      const maxAllowed = customerType === -1 ? Infinity : customerType + 1;
      const remaining =
        maxAllowed - userOfferStatus.usedOfferCount - countOfferSlotsInCart();
      const thisSlotInCart = isOfferAlreadyAppliedInCart(cartSlotKey);
      const wouldExceed = !thisSlotInCart && remaining <= 0;

      if (!slotAlreadyUsed && !thisSlotInCart && !wouldExceed) {
        appliedPrice = offerData.offerPrice;
        isOfferApplied = true;
        finalOfferPrice = offerData.offerPrice;
      } else if (slotAlreadyUsed) {
        appliedPrice = regularPrice;
        isOfferApplied = false;
        fireToast({ title: `Offer already used for this session today.` });
      } else if (wouldExceed) {
        appliedPrice = regularPrice;
        isOfferApplied = false;
        fireToast({ title: `Offer limit reached. Added at regular price.` });
      } else {
        appliedPrice = regularPrice;
        isOfferApplied = false;
        fireToast({ title: `Offer already applied for this session.` });
      }
    } else {
      appliedPrice = regularPrice;
    }

    const itemToAdd = {
      _id: item?._id,
      foodname: item?.foodname,
      itemName: item?.foodname,
      image: item?.Foodgallery?.[0]?.image2,
      unit: item?.unit,
      gst: item?.gst,
      discount: item?.discount,
      foodcategory: item?.foodcategory,
      remainingstock: matchedLocation?.Remainingstock,
      deliveryCharge: deliveryRate,
      price: appliedPrice,
      actualPrice: matchedLocation?.hubPrice || item?.hubPrice || 0,
      basePrice: matchedLocation?.basePrice || item?.basePrice || 0,
      hubPrice: matchedLocation?.hubPrice || item?.hubPrice || 0,
      preOrderPrice: matchedLocation?.preOrderPrice || item?.preOrderPrice || 0,
      offerProduct: !!(offerData && offerData.isOffer),
      offerApplied: isOfferApplied,
      offerPrice: finalOfferPrice,
      regularPrice: finalRegularPrice,
      minCart: offerData?.minCart || 0,
      customerType: offerData?.customerType || null,
      hubId: matchedLocation?.hubId || item?.hubId,
      hubName: matchedLocation?.hubName,
    };

    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    const cartId = `${item._id}-${dateStr}-${selectedSession.toLowerCase()}`;
    const exists = cart.some((c) => c.cartId === cartId);

    if (exists) {
      fireToast({ title: `Item is already in this slot's cart` });
      return;
    }

    addToCart(itemToAdd, selectedDate, selectedSession, 1, {
      offerProduct: !!(offerData && offerData.isOffer),
      offerPrice: finalOfferPrice,
      regularPrice: finalRegularPrice,
      offerApplied: isOfferApplied,
    });

    const updatedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCarts(updatedCart);
    handleShow();

    if (isOfferApplied) {
      triggerConfetti();
      fireToast({
        title: `🎉 Yay! Special offer applied!`,
        subtitle: `You saved ₹${regularPrice - finalOfferPrice}! Now at just ₹${finalOfferPrice}`,
      });
    }
  };

  // Add a window product to cart — qty is reserved atomically at payment time, not here.
  const addWindowCart = (item) => {
    if (!user) {
      fireToast({ title: "Login to continue" });
      return;
    }
    // The window must actually be open for the selected session right now. Without
    // this, a tap at the exact windowEnd (products still painted for ~1s) would add
    // an item the next reconcile tick immediately removes.
    if (!isInWindow) {
      fireToast({ title: "This window has closed.", icon: cross });
      return;
    }
    const pid = String(item.productId?._id || item.productId);
    const wQty = windowQtyMap[pid] ?? item.windowRemainingQuantity ?? 0;
    if (wQty === 0) {
      fireToast({ title: "Sorry, this item is sold out!", icon: cross });
      return;
    }
    const currentCartQty = getCartQuantity(pid);
    if (currentCartQty >= wQty) {
      fireToast({
        title: `No more stock available! Only ${wQty} portion${wQty !== 1 ? "s" : ""} left.`,
        icon: cross,
      });
      return;
    }
    const foodItem = item.productId;
    // Window portions are charged at the window price, not the pre-cutoff hub price.
    // Must match the card's itemPrice or the cart will disagree with what was shown.
    const regularPrice =
      item.windowPrice ?? item.hubPrice ?? item.basePrice ?? 0;
    const itemToAdd = {
      _id: pid,
      foodItemId: pid,
      foodname: foodItem?.foodname || item.productName || "",
      itemName: foodItem?.foodname || item.productName || "",
      image: foodItem?.Foodgallery?.[0]?.image2 || "",
      unit: foodItem?.unit || "",
      gst: foodItem?.gst || 0,
      foodcategory: foodItem?.foodcategory || "",
      remainingstock: windowQtyMap[pid] ?? item.windowRemainingQuantity,
      deliveryCharge: deliveryRate,
      price: regularPrice,
      actualPrice: regularPrice,
      basePrice: regularPrice,
      hubPrice: regularPrice,
      preOrderPrice: item.preOrderPrice || 0,
      hubId: effectiveHubId,
      hubName: "",
      isWindowItem: true,
      orderMode: "window",
      offerProduct: false,
      offerApplied: false,
      offerPrice: null,
      regularPrice,
    };
    addToCart(itemToAdd, selectedDate, selectedSession, 1, {
      offerProduct: false,
      offerPrice: null,
      regularPrice,
      offerApplied: false,
    });
    const updatedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCarts(updatedCart);
    handleShow();
  };

  // Decrease a window cart item by 1 — no pool call needed (reservation happens at payment time)
  const decreaseWindowCart = (item) => {
    const pid = String(item.productId?._id || item.productId);
    const now =
      selectedDate instanceof Date ? selectedDate : new Date(selectedDate);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const dateStr = `${year}-${month}-${day}`;
    const sessionLower = selectedSession.toLowerCase();
    const existing = Carts.find(
      (c) =>
        c._id === pid &&
        c.deliveryDate === dateStr &&
        c.session === sessionLower,
    );
    if (!existing) return;
    const newQty = (existing.quantity || 1) - 1;
    let updatedCart;
    if (newQty <= 0) {
      updatedCart = Carts.filter(
        (c) =>
          !(
            c._id === pid &&
            c.deliveryDate === dateStr &&
            c.session === sessionLower
          ),
      );
    } else {
      updatedCart = Carts.map((c) =>
        c._id === pid &&
        c.deliveryDate === dateStr &&
        c.session === sessionLower
          ? { ...c, quantity: newQty, totalPrice: (c.price || 0) * newQty }
          : c,
      );
    }
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    setCarts(updatedCart);
  };

  const [cart, setCart] = useState([]);

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(storedCart);
    const addonedCarts = async () => {
      try {
        await axios.post("https://dailydish.in/api/cart/addCart", {
          userId: user?._id,
          items: storedCart,
          lastUpdated: Date.now,
          username: user?.Fname,
          mobile: user?.Mobile,
        });
      } catch (error) {
        console.log(error);
      }
    };
    if (Carts && Carts.length > 0 && user?._id) {
      addonedCarts();
    }
  }, [JSON.stringify(Carts), user?._id]);

  const updateCartData = (updatedCart) => {
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    setCart(updatedCart);
    setCarts(updatedCart);
  };

  const increaseQuantity = (foodItemId, offerData, item, matchedLocation) => {
    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
    const day = String(selectedDate.getDate()).padStart(2, "0");
    const selectedDateStr = `${year}-${month}-${day}`;
    const sessionLower = selectedSession.toLowerCase();

    const existingItem = Carts.find(
      (cartItem) =>
        cartItem._id === foodItemId &&
        cartItem.deliveryDate === selectedDateStr &&
        cartItem.session === sessionLower,
    );
    if (!existingItem) return;

    const maxStock =
      existingItem.remainingstock || matchedLocation?.Remainingstock || 0;
    const currentQuantity = existingItem.quantity ?? existingItem.Quantity ?? 0;
    const newQuantity = currentQuantity + 1;

    if (!isOrderingAllowed) {
      fireToast({
        title:
          cutoffValidation.message ||
          `Cannot increase quantity. Orders are closed for ${selectedSession}.`,
      });
      return;
    }

    if (newQuantity > maxStock) {
      fireToast({
        title: `No more stock available! Only ${maxStock} left.`,
        icon: cross,
      });
      return;
    }

    const regularPrice =
      existingItem.regularPrice ||
      existingItem.hubPrice ||
      matchedLocation?.hubPrice ||
      115;
    const offerPrice = existingItem.offerPrice;
    const gotOfferPrice = existingItem.offerApplied === true;

    let newPricePerUnit;
    let newTotalPrice;
    let newOfferApplied = gotOfferPrice;
    let newOfferSavings = 0;

    if (gotOfferPrice && offerPrice) {
      if (currentQuantity === 1 && newQuantity === 2) {
        newPricePerUnit = regularPrice;
        newTotalPrice = offerPrice + regularPrice;
        newOfferSavings = regularPrice * 2 - newTotalPrice;
      } else if (currentQuantity >= 2) {
        newPricePerUnit = regularPrice;
        newTotalPrice = existingItem.totalPrice + regularPrice;
        newOfferSavings = regularPrice * newQuantity - newTotalPrice;
      } else {
        newTotalPrice = offerPrice + regularPrice * (newQuantity - 1);
        newPricePerUnit = regularPrice;
        newOfferSavings = regularPrice * newQuantity - newTotalPrice;
      }
    } else {
      newPricePerUnit = regularPrice;
      newTotalPrice = regularPrice * newQuantity;
      newOfferApplied = false;
    }

    const updatedCart = Carts.map((cartItem) => {
      if (
        cartItem._id === foodItemId &&
        cartItem.deliveryDate === selectedDateStr &&
        cartItem.session === sessionLower
      ) {
        return {
          ...cartItem,
          quantity: newQuantity,
          Quantity: newQuantity,
          price: newPricePerUnit,
          totalPrice: newTotalPrice,
          offerApplied: newOfferApplied,
          offerSavings: newOfferSavings,
          offerProduct: cartItem.offerProduct,
          offerPrice: cartItem.offerPrice,
          regularPrice: cartItem.regularPrice,
        };
      }
      return cartItem;
    });

    updateCartData(updatedCart);

    if (gotOfferPrice && currentQuantity === 1 && newQuantity === 2) {
      fireToast({
        title: `Adding at full price — welcome price already used.`,
      });
    }
  };

  const [show, setShow] = useState(true);
  const [expiryDays, setExpiryDays] = useState(0);

  const decreaseQuantity = (foodItemId, offerData, matchedLocation) => {
    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
    const day = String(selectedDate.getDate()).padStart(2, "0");
    const selectedDateStr = `${year}-${month}-${day}`;
    const sessionLower = selectedSession.toLowerCase();

    const existingItem = Carts.find(
      (cartItem) =>
        cartItem._id === foodItemId &&
        cartItem.deliveryDate === selectedDateStr &&
        cartItem.session === sessionLower,
    );
    if (!existingItem) return;

    const currentQuantity = existingItem.quantity;
    const newQuantity = currentQuantity - 1;

    if (!isOrderingAllowed) {
      fireToast({
        title:
          cutoffValidation.message ||
          `Cannot decrease quantity. Orders are closed for ${selectedSession}.`,
      });
      return;
    }

    if (newQuantity <= 0) {
      const updatedCart = Carts.filter(
        (cartItem) =>
          !(
            cartItem._id === foodItemId &&
            cartItem.deliveryDate === selectedDateStr &&
            cartItem.session === sessionLower
          ),
      );
      updateCartData(updatedCart);
      return;
    }

    const regularPrice =
      existingItem.regularPrice ||
      existingItem.hubPrice ||
      matchedLocation?.hubPrice ||
      115;
    const offerPrice = existingItem.offerPrice;
    const gotOfferPrice = existingItem.offerApplied === true;

    let newPricePerUnit;
    let newTotalPrice;
    let newOfferApplied = gotOfferPrice;
    let newOfferSavings = 0;

    if (gotOfferPrice && offerPrice) {
      if (currentQuantity === 2 && newQuantity === 1) {
        newPricePerUnit = offerPrice;
        newTotalPrice = offerPrice;
        newOfferSavings = regularPrice - offerPrice;
      } else if (currentQuantity > 2 && newQuantity >= 2) {
        newTotalPrice = offerPrice + regularPrice * (newQuantity - 1);
        newPricePerUnit = regularPrice;
        newOfferSavings = regularPrice * newQuantity - newTotalPrice;
      } else {
        newTotalPrice = offerPrice + regularPrice * (newQuantity - 1);
        newPricePerUnit = regularPrice;
        newOfferSavings = regularPrice * newQuantity - newTotalPrice;
      }
    } else {
      newPricePerUnit = regularPrice;
      newTotalPrice = regularPrice * newQuantity;
      newOfferApplied = false;
    }

    const updatedCart = Carts.map((cartItem) => {
      if (
        cartItem._id === foodItemId &&
        cartItem.deliveryDate === selectedDateStr &&
        cartItem.session === sessionLower
      ) {
        return {
          ...cartItem,
          quantity: newQuantity,
          price: newPricePerUnit,
          totalPrice: newTotalPrice,
          offerApplied: newOfferApplied,
          offerSavings: newOfferSavings,
          offerProduct: cartItem.offerProduct,
          offerPrice: cartItem.offerPrice,
          regularPrice: cartItem.regularPrice,
        };
      }
      return cartItem;
    });

    updateCartData(updatedCart);
  };

  const groupedCarts = useMemo(() => {
    if (!Carts || Carts.length === 0) return [];
    const groups = Carts.reduce((acc, item) => {
      const key = `${item.deliveryDate}|${item.session}`;
      if (!item.deliveryDate || !item.session) return acc;
      // Normalize session to title case for consistent display and jumping
      const normalizedSession =
        item.session.charAt(0).toUpperCase() +
        item.session.slice(1).toLowerCase();
      if (!acc[key]) {
        acc[key] = {
          session: normalizedSession,
          date: new Date(item.deliveryDate),
          totalItems: 0,
          subtotal: 0,
          items: [],
        };
      }
      acc[key].totalItems += item.quantity || item.Quantity || 0;
      acc[key].subtotal +=
        (item.price || 0) * (item.quantity || item.Quantity || 0);
      acc[key].items.push(item);
      return acc;
    }, {});
    return Object.values(groups).sort((a, b) => a.date - b.date);
  }, [Carts]);

  const overallTotalItems = useMemo(
    () => groupedCarts.reduce((acc, slot) => acc + slot.totalItems, 0),
    [groupedCarts],
  );
  const overallSubtotal = useMemo(
    () => groupedCarts.reduce((acc, slot) => acc + slot.subtotal, 0),
    [groupedCarts],
  );

  const proceedToCheckout = () => {
    if (!user) {
      fireToast({ title: `Please Login!` });
      return;
    }
    if (Carts.length === 0) return;
    if (!address) {
      fireToast({ title: `Please Select Address!` });
      return;
    }
    // Pass the already-fetched delivery rate record so checkout doesn't need to re-fetch
    const deliveryStatus = user?.status === "Employee" ? "Employee" : "Normal";
    const rateRecord = findDeliveryRateRecord(address?.hubId, deliveryStatus);
    navigate("/checkout-multiple", {
      state: { deliveryRateRecord: rateRecord },
    });
  };

  const getCartQuantity = (itemId) => {
    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
    const day = String(selectedDate.getDate()).padStart(2, "0");
    const selectedDateStr = `${year}-${month}-${day}`;
    const sessionLower = selectedSession.toLowerCase();
    const matchingItems = Carts?.filter(
      (cartItem) =>
        (cartItem?._id === itemId || cartItem?.foodItemId === itemId) &&
        cartItem.deliveryDate === selectedDateStr &&
        cartItem.session === sessionLower,
    );
    const totalQuantity = matchingItems?.reduce(
      (total, curr) => total + (curr?.quantity || curr?.Quantity || 0),
      0,
    );
    return totalQuantity || 0;
  };

  useEffect(() => {
    const checkCutoffForDisplay = async () => {
      if (effectiveHubId && selectedDate && selectedSession) {
        await validateCutoffTiming(
          effectiveHubId,
          selectedSession,
          selectedDate,
        );
      }
    };
    checkCutoffForDisplay();
  }, [effectiveHubId, selectedDate, selectedSession, validateCutoffTiming]);

  const lastCartRawRef = useRef(null);
  useEffect(() => {
    const readCart = () => {
      try {
        const raw = localStorage.getItem("cart") || "[]";
        if (raw !== lastCartRawRef.current) {
          lastCartRawRef.current = raw;
          const parsed = JSON.parse(raw);
          setCarts(Array.isArray(parsed) ? parsed : []);
          setCart(Array.isArray(parsed) ? parsed : []);
        }
      } catch (err) {
        console.error("cart sync error", err);
      }
    };
    readCart();
    const intervalId = setInterval(readCart, 1000);
    const onStorage = (e) => {
      if (e.key === "cart") readCart();
    };
    const onCartUpdated = () => readCart();
    window.addEventListener("storage", onStorage);
    window.addEventListener("cart_updated", onCartUpdated);
    return () => {
      clearInterval(intervalId);
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("cart_updated", onCartUpdated);
    };
  }, [setCarts]);

  useEffect(() => {
    localStorage.removeItem("triggerProceedToPlan");
    sessionStorage.removeItem("justAddedAddress");
  }, []);

  return (
    <div>
      <ToastContainer />
      {/* ── Offer Unlocked Modal (shown after navigating from UpdateLocation with a fresh hubOffer) ── */}
      <OfferUnlockedModal
        isOpen={showOfferModal}
        offerData={offerModalData}
        onClose={() => setShowOfferModal(false)}
      />
      {/* ── "Closed on Sundays" heads-up — RETIRED. Replaced by the
           "Kitchens deep-cleaned today" pill inside the cutoff card
           (CutoffTimer.jsx), shown on Sat & Sun. Modal kept dormant below. ── */}
      {/* <SundayClosedModal
        isOpen={sundayModalPending && !showOfferModal}
        mondayLabel={sundayMondayLabel}
        onClose={dismissSundayModal}
      /> */}
      <div>
        <Banner
          Carts={Carts}
          isVegOnly={isVegOnly}
          setIsVegOnly={setIsVegOnly}
          onLocationDetected={handleLocationDetected}
        />
      </div>

      {/* Logged-out visitors: free-meal promo image (logged-in users get the
          gift icon + panel in the cutoff strip instead) */}
      {!user && <FreeMealBanner />}

      {/* Logged-out visitors: "Why DailyDish?" shimmer bar → PreorderInfoModal
          (logged-in users get the minimal (i) link below DateSessionSelector) */}
      {!user && <WhyDailyDishBar onClick={() => setShowWhyModal(true)} />}

      {user &&
        effectiveHubId &&
        selectedDate &&
        selectedSession &&
        hubSettled &&
        effectiveCutoffValidation?.cutoffDateTime && (
          <CutoffStickyWrapper>
            <CutoffStatusCard
              selectedDate={selectedDate}
              selectedSession={selectedSession}
              userStatus={user?.status}
              cutoffValidation={effectiveCutoffValidation}
              cutoffLoading={false}
              currentSelectedDate={selectedDate}
              isInWindow={isInWindow}
              windowEnd={getWindowEnd(selectedSession, hubLocalCutoffData)}
              hubId={hubLocalCutoffData?.hubId}
              hubType={hubLocalCutoffData?.hubType}
              offer={(() => {
                // Same eligibility gating the old green banner used:
                // logged-in, non-employee, active hubOffer for THIS hub, meals left
                if (!user || user.status === "Employee") return null;
                if (!acqOfferStatus || acqOfferStatus === false) return null;
                if (
                  acqOfferStatus.hubId &&
                  effectiveHubId &&
                  acqOfferStatus.hubId !== effectiveHubId.toString()
                )
                  return null;
                if (
                  !acqOfferStatus.mealsRemaining ||
                  acqOfferStatus.mealsRemaining <= 0
                )
                  return null;
                return acqOfferStatus;
              })()}
            />
          </CutoffStickyWrapper>
        )}

      {/* <FreshIngredientsCarousel /> */}

      {/* New User Offer Banner */}
      {/* {(() => {
        // Never show for employees
        if (user?.status === "Employee") return null;

        // Wait for offer status data before rendering for logged-in users.
        // Without this guard, usedOfferCount starts at 0 so the banner flashes
        // briefly on every refresh even when all offers are used.
        if (user && !offerStatusLoaded) return null;

        const ordersWithOffer = user ? userOfferStatus.usedOfferCount : 0;
        const maxIntroOrders = 3;
        const introRemaining = Math.max(0, maxIntroOrders - ordersWithOffer);

        // Hide once all intro orders are used (logged-in only)
        if (user && introRemaining <= 0) return null;

        // Hide for old users who have placed more orders than the intro limit
        if (user && userOrderCount > maxIntroOrders) return null;

        const headlineMap = {
          3: "3 dishes remaining at welcome price",
          2: "2 dishes remaining at welcome price",
          1: "1 dish remaining at welcome price",
        };
        const heading = user
          ? headlineMap[introRemaining] ||
            introRemaining + " trial dish left"
          : "Your first 3 meals at ₹25";
        const subtext = user
          ? "One per session · New users only · Sahakarnagar hub only"
          : "3 discounted dishes · one per slot · New users only · Sahakarnagar hub only";

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto",
              borderBottomLeftRadius: "16px",
              borderBottomRightRadius: "16px",
              borderTop: "none", // Remove top border if needed
            }}
            className="user-banner-home"
          >
            <div
              style={{
                backgroundColor: "#3d6701",
                padding: "10px 16px",
                // borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                borderBottomLeftRadius: "16px",
              borderBottomRightRadius: "16px",
              borderTop: "none", // Remove top border if needed
              }}
            >
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    color: "#ffffff",
                    fontWeight: "700",
                    fontSize: "14px",
                    lineHeight: "1.3",
                  }}
                >
                  {heading}
                </div>
                <div
                  style={{
                    color: "#ffffff",
                    fontSize: "12px",
                    marginTop: "2px",
                  }}
                >
                  {subtext}
                </div>
              </div>
              <div
                style={{
                  backgroundColor: "#f5c842",
                  color: "#3b1a00",
                  fontWeight: "700",
                  fontSize: "13px",
                  borderRadius: "20px",
                  padding: "4px 12px",
                  whiteSpace: "nowrap",
                  marginLeft: "12px",
                }}
              >
                ₹25 only
              </div>
            </div>
          </div>
        );
      })()} */}

      {/* ── Hub Acquisition Offer Banner — RETIRED: replaced by the gift icon +
          dropdown panel inside the cutoff strip (CutoffStatusCard `offer` prop).
          Early return keeps the old markup dormant. ── */}
      {(() => {
        return null;
        // eslint-disable-next-line no-unreachable
        // Only show to logged-in, non-employee users with an active hubOffer
        if (!user || user.status === "Employee") return null;
        if (!acqOfferStatus || acqOfferStatus === false) return null;

        // Only show for the hub the offer was issued to — hide when user switches hub
        if (
          acqOfferStatus.hubId &&
          effectiveHubId &&
          acqOfferStatus.hubId !== effectiveHubId.toString()
        )
          return null;

        const {
          mealsRemaining,
          daysRemaining,
          offerCap,
          mealsPerValidity,
          usedToday,
          eligible,
          campaignEndDate,
        } = acqOfferStatus;

        const fmtCampaignEnd = campaignEndDate
          ? new Date(campaignEndDate).toLocaleDateString("en-IN", {
              day: "numeric",
              month: "short",
            })
          : null;

        // Don't show if no meals left
        if (!mealsRemaining || mealsRemaining <= 0) return null;

        // "Come back tomorrow" — used meal today but still has remaining meals
        if (usedToday && !eligible) {
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto",
                borderBottomLeftRadius: "16px",
                borderBottomRightRadius: "16px",
                borderTop: "none",
              }}
              className="user-banner-home"
            >
              <div
                style={{
                  backgroundColor: "rgb(61, 103, 1)",
                  padding: "10px 16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  borderBottomLeftRadius: "16px",
                  borderBottomRightRadius: "16px",
                  borderTop: "none",
                }}
              >
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      color: "#ffffff",
                      fontWeight: "700",
                      fontSize: "14px",
                      lineHeight: "1.3",
                    }}
                  >
                    🎁 Free meal used today
                  </div>
                  <div
                    style={{
                      color: "rgba(255,255,255,0.8)",
                      fontSize: "12px",
                      marginTop: "2px",
                    }}
                  >
                    {mealsRemaining} meal{mealsRemaining !== 1 ? "s" : ""}{" "}
                    remaining · Come back tomorrow
                    {fmtCampaignEnd && ` · Offer valid until ${fmtCampaignEnd}`}
                  </div>
                </div>
                <div
                  style={{
                    backgroundColor: "rgba(255,255,255,0.2)",
                    color: "#ffffff",
                    fontWeight: "700",
                    fontSize: "12px",
                    borderRadius: "20px",
                    padding: "4px 12px",
                    whiteSpace: "nowrap",
                    marginLeft: "12px",
                  }}
                >
                  {daysRemaining}d left
                </div>
              </div>
            </div>
          );
        }

        // Active offer — can use today
        const heading =
          mealsRemaining === mealsPerValidity
            ? `🎁 ${mealsRemaining} free meals waiting for you`
            : `🎁 ${mealsRemaining} free meal${mealsRemaining !== 1 ? "s" : ""} remaining`;
        const subtext = `Up to ₹${offerCap} off · ${daysRemaining} day${daysRemaining !== 1 ? "s" : ""} left · One per day${fmtCampaignEnd ? ` · Valid until ${fmtCampaignEnd}` : ""}`;

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto",
              borderBottomLeftRadius: "16px",
              borderBottomRightRadius: "16px",
              borderTop: "none",
            }}
            className="user-banner-home"
          >
            <div
              style={{
                backgroundColor: "rgb(61, 103, 1)",
                padding: "10px 16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                borderBottomLeftRadius: "16px",
                borderBottomRightRadius: "16px",
                borderTop: "none",
              }}
            >
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    color: "#ffffff",
                    fontWeight: "700",
                    fontSize: "14px",
                    lineHeight: "1.3",
                  }}
                >
                  {heading}
                </div>
                <div
                  style={{
                    color: "rgba(255,255,255,0.8)",
                    fontSize: "12px",
                    marginTop: "2px",
                  }}
                >
                  {subtext}
                </div>
              </div>
              <div
                style={{
                  backgroundColor: "#fff",
                  color: "#0a2e0a",
                  fontWeight: "700",
                  fontSize: "13px",
                  borderRadius: "20px",
                  padding: "4px 12px",
                  whiteSpace: "nowrap",
                  marginLeft: "12px",
                }}
              >
                Free
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── Post-Cutoff Window Banner (hidden per request) ──
      {isInWindow &&
        (() => {
          const key = selectedSession?.toLowerCase();
          const times = hubLocalCutoffData?.cutoffTimes?.[key];
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <div
                style={{
                  background: "#FFF8DC",
                  borderTop: "3px solid #E6B800",
                  width: "100%",
                  maxWidth: "655px",
                  padding: "10px 16px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  boxSizing: "border-box",
                }}
              >
                Flame badge

                Text
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      fontWeight: 700,
                      fontSize: "13px",
                      color: "#A0522D",
                      lineHeight: 1.3,
                      letterSpacing: "-0.1px",
                    }}
                  >
                    We cooked a little extra today — grab it while it lasts!
                  </div>
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#8B4513",
                      marginTop: "3px",
                      lineHeight: 1.4,
                    }}
                  >
                    Available until {fmt12h(times?.windowEnd)} · while portions
                    last
                    {times?.defaultCutoff && (
                      <>
                        {" "}
                        · Pre-order before {fmt12h(times.defaultCutoff)} next
                        time
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })()}
      ── */}

      {wallet?.balance > 0 && show && (
        <div style={{ position: "relative" }}>
          <CoinBalance
            wallet={wallet}
            transactions={transactions}
            expiryDays={expiryDays}
            setExpiryDays={setExpiryDays}
            setShow={setShow}
          />
        </div>
      )}

      <div className="sticky-menu-header" style={{ position: "relative" }}>
        <DateSessionSelector
          onChange={handleSelectionChange}
          currentDate={selectedDate}
          currentSession={selectedSession}
          // Hand over the menu only once it belongs to the current hub —
          // otherwise the previous hub's availability paints for a frame
          // (e.g. "See tomorrow" switch flashing on hub change)
          menuData={
            !effectiveHubId || String(menuHubId) === String(effectiveHubId)
              ? allHubMenuData
              : []
          }
          hubCutoffData={hubLocalCutoffData}
          menuLoading={
            loader ||
            Boolean(
              effectiveHubId && String(menuHubId) !== String(effectiveHubId),
            )
          }
          onAvailabilityChange={setAllSessionsClosedToday}
          windowItems={windowItemsBySession}
          noAddress={noLocation}
        />
      </div>

      {/* ── Why DailyDish? — minimal (i) link below the date/session selector.
          Logged-in only: logged-out visitors get the shimmer bar above. ── */}
      {user && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            maxWidth: "655px",
            margin: "4px auto 0",
            padding: "0 16px",
            boxSizing: "border-box",
          }}
        >
          <button
            onClick={() => setShowWhyModal(true)}
            aria-label="Why DailyDish?"
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              fontSize: "12px",
              fontWeight: 600,
              color: "#6b6548",
              padding: "4px 6px",
            }}
          >
            <span
              style={{
                width: "15px",
                height: "15px",
                borderRadius: "50%",
                background: "#e0d8bc",
                color: "#6b6548",
                fontSize: "10px",
                fontWeight: 800,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontStyle: "italic",
                fontFamily: "Georgia, serif",
                flexShrink: 0,
              }}
            >
              i
            </span>
            Why DailyDish?
          </button>
        </div>
      )}
      <PreorderInfoModal
        isOpen={showWhyModal}
        onClose={() => setShowWhyModal(false)}
      />

      <Container>
        <RatingModal />
        {loader ? (
          <div
            className="d-flex justify-content-center align-item-center"
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
            }}
          >
            <div className="lds-ripple">
              <div></div>
              <div></div>
            </div>
          </div>
        ) : null}
      </Container>

      <div className="maincontainer">
        <div className="mobile-product-box" style={{ marginBottom: "30px" }}>
          {!isOrderingAllowed &&
            !isInWindow &&
            vegFilteredItems.length === 0 &&
            hubSettled &&
            cutoffValidation?._forSession === selectedSession?.toLowerCase() &&
            cutoffValidation?._forDate ===
              selectedDate?.toISOString().split("T")[0] && (
              <div
                style={{
                  background: "#FFF3E0",
                  border: "1px solid #FF9800",
                  borderRadius: "12px",
                  padding: "20px",
                  margin: "16px",
                  textAlign: "center",
                }}
              >
                <MdOutlineTimer size={48} color="#FF9800" />
                <h4 style={{ marginTop: "12px", color: "#E65100" }}>
                  Orders Closed for {selectedSession}
                </h4>
                <p style={{ color: "#666" }}>{cutoffValidation.message}</p>
              </div>
            )}
          {/* ── Window products (shown only during post-cutoff window period) ── */}
          {isInWindow && (
            <div className="d-flex gap-1 mb-2 flex-column">
              <div className="row">
                {windowProductsLoading && (
                  <div className="col-12 text-center my-4">
                    <div
                      className="lds-ripple"
                      style={{ display: "inline-block" }}
                    >
                      <div />
                      <div />
                    </div>
                  </div>
                )}
                {!windowProductsLoading && windowProducts.length === 0 && (
                  <div className="col-12 text-center my-5">
                    <h4>No window items available.</h4>
                  </div>
                )}
                {!windowProductsLoading &&
                  windowProducts.map((item, i) => {
                    const pid = String(item.productId?._id || item.productId);
                    const wQty =
                      windowQtyMap[pid] ?? item.windowRemainingQuantity;
                    const isSoldOut = wQty === 0;
                    const foodItem = item.productId || {};
                    const cartQty = getCartQuantity(pid);
                    const isAtWindowLimit = !isSoldOut && cartQty >= wQty;
                    // hubPrice fallback covers deploy skew against a backend that
                    // does not send windowPrice yet.
                    const itemPrice =
                      item.windowPrice ?? item.hubPrice ?? item.basePrice ?? 0;
                    // Backend sends preCutoffPrice only when the window is genuinely
                    // dearer, so its presence alone gates the hint.
                    const preCutoffPrice = item.preCutoffPrice ?? null;
                    const cutoffLabel = formatCutoffTime(
                      getCutoff(
                        selectedSession,
                        hubLocalCutoffData,
                        user?.status === "Employee",
                      ),
                    );
                    const showWindowHint =
                      preCutoffPrice != null && cutoffLabel !== "";
                    return (
                      <div
                        key={pid || i}
                        className="col-6 col-md-6 mb-2 d-flex justify-content-center"
                      >
                        <div className="mobl-product-card">
                          <div
                            className="productborder"
                            style={{ position: "relative" }}
                          >
                            <div className="prduct-box rounded-1 cardbx">
                              <div
                                onClick={() =>
                                  showDrawer({
                                    ...foodItem,
                                    hubPrice: itemPrice,
                                    _id: pid,
                                  })
                                }
                                className="imagebg"
                                style={{ position: "relative" }}
                              >
                                {foodItem?.foodcategory === "Veg" ? (
                                  <img
                                    src={IsVeg}
                                    alt="IsVeg"
                                    className="isVegIcon"
                                  />
                                ) : (
                                  <img
                                    src={IsNonVeg}
                                    alt="IsNonVeg"
                                    className="isVegIcon"
                                  />
                                )}
                                <img
                                  src={foodItem?.Foodgallery?.[0]?.image2 || ""}
                                  alt=""
                                  className="mbl-product-img"
                                />
                              </div>
                            </div>
                            <div className="food-name-container">
                              <p className="food-name">
                                {foodItem?.foodname || item.productName}
                              </p>
                              <small className="food-unit">
                                {foodItem?.unit}
                              </small>
                            </div>
                            <div
                              className="d-flex align-items-center mb-3"
                              style={{
                                gap: "8px",
                                flexWrap: "wrap",
                                paddingLeft: "6px",
                              }}
                            >
                              <div
                                className="align-items-start"
                                style={{
                                  color: "#2c2c2c",
                                  fontFamily: "Inter",
                                  fontSize: "20px",
                                  fontWeight: "500",
                                  lineHeight: "25px",
                                  letterSpacing: "-0.8px",
                                  display: "flex",
                                  gap: "2px",
                                }}
                              >
                                <span className="fw-bold">₹</span>
                                <span>{itemPrice}</span>
                              </div>
                              {/* Hover is unreliable on touch and this is a mobile
                                  card, so the tooltip also opens on tap. The icon
                                  stops propagation because the card itself opens
                                  the product drawer on click. */}
                              {showWindowHint && (
                                <Tooltip
                                  trigger={["hover", "click"]}
                                  color={Colors.warmmarble}
                                  overlayInnerStyle={{
                                    color: Colors.primaryText,
                                  }}
                                  title={
                                    <>
                                      By pre-ordering before{" "}
                                      <strong>{cutoffLabel}</strong>, you'd have
                                      got this at{" "}
                                      <strong>₹{preCutoffPrice}</strong>.
                                    </>
                                  }
                                >
                                  <span
                                    role="button"
                                    tabIndex={0}
                                    className="window-why-btn"
                                    onClick={(e) => e.stopPropagation()}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter" || e.key === " ") {
                                        e.stopPropagation();
                                      }
                                    }}
                                    aria-label="Why is this price higher?"
                                  >
                                    i
                                  </span>
                                </Tooltip>
                              )}
                            </div>
                            <div>
                              <div className="guaranteed-label">
                                <img
                                  src={availabity}
                                  alt=""
                                  style={{ width: "11px", height: "11px" }}
                                />{" "}
                                {wQty} Servings Left
                              </div>
                            </div>
                            <div className="d-flex justify-content-center mb-2">
                              {isSoldOut ? (
                                <button className="sold-out-btn" disabled>
                                  <span className="sold-out-btn-text">
                                    Sold Out
                                  </span>
                                </button>
                              ) : cartQty === 0 ? (
                                <button
                                  className={`add-to-cart-btn ${user && !address ? "disabled-btn" : ""}`}
                                  onClick={() => address && addWindowCart(item)}
                                  disabled={user && !address}
                                  style={{
                                    opacity: user && !address ? 0.5 : 1,
                                    cursor:
                                      user && !address
                                        ? "not-allowed"
                                        : "pointer",
                                  }}
                                >
                                  <div className="pick-btn-text">
                                    <span className="pick-btn-text1">ADD</span>
                                  </div>
                                  <span className="add-to-cart-btn-icon">
                                    <FaPlus />
                                  </span>
                                </button>
                              ) : (
                                <button className="increaseBtn">
                                  <div
                                    className="faplus"
                                    onClick={() => decreaseWindowCart(item)}
                                  >
                                    <FaMinus />
                                  </div>
                                  <div className="faQuantity">{cartQty}</div>
                                  <div
                                    className="faplus"
                                    onClick={() =>
                                      !isSoldOut &&
                                      !isAtWindowLimit &&
                                      addWindowCart(item)
                                    }
                                    style={{
                                      opacity:
                                        isSoldOut || isAtWindowLimit ? 0.5 : 1,
                                      pointerEvents:
                                        isSoldOut || isAtWindowLimit
                                          ? "none"
                                          : "auto",
                                    }}
                                  >
                                    <FaPlus />
                                  </div>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          )}
          {/* ── Regular products (hidden during window period) ── */}
          {!isInWindow && (
            <div className="d-flex gap-1 mb-2 flex-column">
              <div className="row">
                {/* ── Customisable Combos launcher ──
                    Rendered first so it leads the grid. Not a product: it never
                    enters the cart and has no hub/price of its own. It only opens
                    the modal listing the "Combos" category for the current slot,
                    each of which is an ordinary menu row. */}
                {comboItems.length > 0 && (
                  <div className="col-6 col-md-6 mb-2 d-flex justify-content-center">
                    <div className="mobl-product-card">
                      <div
                        className="productborder"
                        style={{ position: "relative" }}
                      >
                        <div className="prduct-box rounded-1 cardbx">
                          <div
                            className="imagebg"
                            onClick={() => setShowCombosModal(true)}
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={combosImg}
                              alt="Customisable Combos"
                              className="mbl-product-img"
                            />
                          </div>
                        </div>
                        <div className="food-name-container">
                          <p className="food-name">Customisable Combos</p>
                          <small className="food-unit combo-launcher-subtitle">
                            Build your own combo
                          </small>
                        </div>
                        <div className="combo-launcher-spacer" />
                        <div>
                          <div className="guaranteed-label">
                            <img
                              src={availabity}
                              alt=""
                              style={{ width: "11px", height: "11px" }}
                            />{" "}
                            Guaranteed Availability
                          </div>
                        </div>
                        <div className="d-flex justify-content-center mb-2">
                          <button
                            className={`add-to-cart-btn ${
                              (user && !address) || !isOrderingAllowed
                                ? "disabled-btn"
                                : ""
                            }`}
                            onClick={() => setShowCombosModal(true)}
                            disabled={(user && !address) || !isOrderingAllowed}
                            style={{
                              opacity:
                                (user && !address) || !isOrderingAllowed
                                  ? 0.5
                                  : 1,
                              cursor:
                                (user && !address) || !isOrderingAllowed
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                          >
                            <div className="pick-btn-text combo-customise-label">
                              <span className="pick-btn-text1">CUSTOMISE</span>
                            </div>
                            <span className="add-to-cart-btn-icon">
                              <BsCartPlus />
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {finalDisplayItems?.map((item, i) => {
                  let matchedLocation = item.locationPrice?.[0] || {
                    Remainingstock: 0,
                    hubPrice: item.hubPrice || item.basePrice || 0,
                    preOrderPrice: item.preOrderPrice || 0,
                    basePrice: item.basePrice || 0,
                  };

                  const productOffer = getProductOffer(item);
                  const slotKey = `${selectedDate.toISOString().split("T")[0]}|${selectedSession.toLowerCase()}`;
                  const hasOfferInCart = isOfferAlreadyAppliedInCart(slotKey);
                  // Only evaluate offer display once both offers and order history have loaded.
                  // This prevents the flicker where the price briefly shows the offer price
                  // (or original price) before the eligibility check data is available.
                  // For non-logged-in users, no user-specific data is needed so skip the wait.
                  const offerDataReady =
                    !user || (offerStatusLoaded && ordersLoaded);
                  const showOfferPrice =
                    offerDataReady &&
                    productOffer &&
                    !hasOfferInCart &&
                    !productOffer.isBlocked;

                  // Debug log for offer items only
                  // if (item.isOffer) {
                  //   console.log("[OFFER DEBUG] Card render for:", item.foodname, {
                  //     offerDataReady,
                  //     offerStatusLoaded,
                  //     ordersLoaded,
                  //     productOffer: productOffer ? "✅ eligible" : "❌ null",
                  //     hasOfferInCart,
                  //     isBlocked: productOffer?.isBlocked,
                  //     showOfferPrice: !!showOfferPrice,
                  //     user: user ? user._id : "not logged in",
                  //     userOrderCount,
                  //     userOfferStatus,
                  //   });
                  // }
                  const { price: effectivePrice } = getEffectivePrice(
                    item,
                    matchedLocation,
                    item?.session,
                  );
                  const selectedDateISO = selectedDate.toISOString();
                  const cartItem = Carts.find(
                    (cartItem) =>
                      cartItem?.foodItemId === item?._id &&
                      cartItem.deliveryDate === selectedDateISO &&
                      cartItem.session === selectedSession,
                  );

                  let displayPrice = effectivePrice;
                  let offerPrice = null;

                  if (cartItem && typeof cartItem.totalPrice === "number") {
                    // If the item is in cart with offer applied, show cart total and strikethrough regular
                    if (cartItem.offerApplied) {
                      displayPrice = Math.round(cartItem.totalPrice);
                      if (cartItem.Quantity > 1 && cartItem.regularPrice) {
                        offerPrice = Math.round(
                          cartItem.regularPrice * cartItem.Quantity,
                        );
                      }
                    } else if (showOfferPrice && productOffer?.offerPrice) {
                      // Item is in cart at regular price (offer limit exceeded) but offer still exists —
                      // keep showing the offer price so the user knows what the offer is.
                      displayPrice = productOffer.offerPrice;
                      offerPrice = effectivePrice;
                    } else {
                      displayPrice = Math.round(cartItem.totalPrice);
                    }
                  } else if (showOfferPrice && productOffer?.offerPrice) {
                    displayPrice = productOffer.offerPrice;
                    offerPrice = effectivePrice;
                  }

                  return (
                    <div
                      key={item._id?.toString() || i}
                      className="col-6 col-md-6 mb-2 d-flex justify-content-center"
                    >
                      <div className="mobl-product-card">
                        <div
                          className="productborder"
                          style={{ position: "relative" }}
                        >
                          {showOfferPrice && (
                            <div className="premium-offer-badge">
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                style={{ marginRight: "6px" }}
                              >
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                              </svg>
                              <span>WELCOME OFFER</span>
                            </div>
                          )}
                          <div className="prduct-box rounded-1 cardbx">
                            <div
                              onClick={() => showDrawer(item)}
                              className="imagebg"
                            >
                              {item?.foodcategory === "Veg" ? (
                                <img
                                  src={IsVeg}
                                  alt="IsVeg"
                                  className="isVegIcon"
                                />
                              ) : (
                                <img
                                  src={IsNonVeg}
                                  alt="IsNonVeg"
                                  className="isVegIcon"
                                />
                              )}
                              <img
                                src={`${item?.Foodgallery[0]?.image2}`}
                                alt=""
                                className="mbl-product-img"
                              />
                            </div>
                          </div>
                          {/* {item?.foodTags && (
                            <div className="food-tag-container">
                              {item.foodTags.map((tag, idx) => (
                                <span
                                  key={idx}
                                  className="food-tag-pill"
                                  style={{ backgroundColor: tag.tagColor }}
                                >
                                  <img
                                    src={chef}
                                    alt=""
                                    style={{
                                      width: "10px",
                                      height: "10px",
                                      marginRight: "2px",
                                    }}
                                  />
                                  {tag.tagName}
                                </span>
                              ))}
                            </div>
                          )} */}
                          <div className="food-name-container">
                            <p className="food-name">{item?.foodname}</p>
                            <small className="food-unit">{item?.unit}</small>
                          </div>
                          <div
                            className="d-flex align-items-center mb-3"
                            style={{
                              gap: "8px",
                              flexWrap: "wrap",
                              paddingLeft: "6px",
                            }}
                          >
                            <div
                              className="d-flex align-items-center"
                              style={{ gap: "8px" }}
                            >
                              {offerPrice && (
                                <div
                                  className="align-items-start"
                                  style={{
                                    textDecoration: "line-through",
                                    color: "#6b6b6b",
                                    fontSize: "15px",
                                    whiteSpace: "nowrap",
                                    flexShrink: 0,
                                    display: "flex",
                                    gap: "2px",
                                  }}
                                >
                                  <span className="fw-normal">₹</span>
                                  <span>{offerPrice}</span>
                                </div>
                              )}
                              <div
                                className="align-items-start"
                                style={{
                                  color: "#2c2c2c",
                                  fontFamily: "Inter",
                                  fontSize: "20px",
                                  fontWeight: "500",
                                  lineHeight: "25px",
                                  letterSpacing: "-0.8px",
                                  whiteSpace: "nowrap",
                                  flexShrink: 0,
                                  display: "flex",
                                  gap: "2px",
                                }}
                              >
                                <div
                                  className="align-items-start"
                                  style={{
                                    display: "flex",
                                    gap: "1px",
                                  }}
                                >
                                  <span className="fw-bold">₹</span>
                                  <span>{displayPrice}</span>
                                </div>
                              </div>
                            </div>
                            {showOfferPrice && offerPrice && (
                              <div className="offer-percentage-badge">
                                {Math.round(
                                  ((offerPrice - displayPrice) / offerPrice) *
                                    100,
                                )}
                                % OFF
                              </div>
                            )}
                          </div>
                          <div>
                            <div className="guaranteed-label">
                              <img
                                src={availabity}
                                alt=""
                                style={{ width: "11px", height: "11px" }}
                              />{" "}
                              Guaranteed Availability
                            </div>
                          </div>
                          <div className="d-flex justify-content-center mb-2">
                            {getCartQuantity(item?._id) === 0 ? (
                              address && gifUrl === "Closed.gif" ? (
                                <button
                                  className="add-to-cart-btn-disabled"
                                  disabled
                                >
                                  <span className="add-to-cart-btn-text">
                                    Add
                                  </span>
                                  <FaPlus className="add-to-cart-btn-icon" />
                                </button>
                              ) : (
                                <button
                                  className={`add-to-cart-btn ${(user && !address) || !isOrderingAllowed ? "disabled-btn" : ""}`}
                                  onClick={() =>
                                    addCart1(
                                      item,
                                      productOffer,
                                      matchedLocation,
                                    )
                                  }
                                  disabled={
                                    (user && !address) || !isOrderingAllowed
                                  }
                                  style={{
                                    opacity:
                                      (user && !address) || !isOrderingAllowed
                                        ? 0.5
                                        : 1,
                                    cursor:
                                      (user && !address) || !isOrderingAllowed
                                        ? "not-allowed"
                                        : "pointer",
                                  }}
                                >
                                  <div className="pick-btn-text">
                                    <span className="pick-btn-text1">ADD</span>
                                  </div>
                                  <span className="add-to-cart-btn-icon">
                                    <FaPlus />
                                  </span>
                                </button>
                              )
                            ) : getCartQuantity(item?._id) > 0 ? (
                              <button className="increaseBtn">
                                <div
                                  className="faplus"
                                  onClick={() =>
                                    !(user && !address) && !isOrderingAllowed
                                      ? null
                                      : decreaseQuantity(
                                          item?._id,
                                          productOffer,
                                          matchedLocation,
                                        )
                                  }
                                  style={{
                                    opacity:
                                      (user && !address) || !isOrderingAllowed
                                        ? 0.5
                                        : 1,
                                    pointerEvents:
                                      (user && !address) || !isOrderingAllowed
                                        ? "none"
                                        : "auto",
                                  }}
                                >
                                  <FaMinus />
                                </div>
                                <div className="faQuantity">
                                  {getCartQuantity(item?._id)}
                                </div>
                                <div
                                  className="faplus"
                                  onClick={() =>
                                    !(user && !address) && !isOrderingAllowed
                                      ? null
                                      : increaseQuantity(
                                          item?._id,
                                          productOffer,
                                          item,
                                          matchedLocation,
                                        )
                                  }
                                  style={{
                                    opacity:
                                      (user && !address) || !isOrderingAllowed
                                        ? 0.5
                                        : 1,
                                    pointerEvents:
                                      (user && !address) || !isOrderingAllowed
                                        ? "none"
                                        : "auto",
                                  }}
                                >
                                  <FaPlus />
                                </div>
                              </button>
                            ) : gifUrl === "Closed.gif" ? (
                              <button className="add-to-cart-btn" disabled>
                                <span className="add-to-cart-btn-text">
                                  Add
                                </span>
                                <span className="add-to-cart-btn-icon">
                                  <FaPlus />
                                </span>
                              </button>
                            ) : (
                              <button
                                className="add-to-cart-btn"
                                onClick={() =>
                                  addCart1(item, productOffer, matchedLocation)
                                }
                                disabled={user && !address}
                                style={{ opacity: user && !address ? 0.5 : 1 }}
                              >
                                <span className="add-to-cart-btn-text">
                                  Add
                                </span>
                                <span className="add-to-cart-btn-icon">
                                  <FaPlus />
                                </span>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {!loader &&
                  !cutoffLoading &&
                  vegFilteredItems.length === 0 &&
                  isOrderingAllowed &&
                  (() => {
                    // noLocation is computed at component scope above

                    // "No items available for this slot" removed for ALL cases —
                    // DateSessionSelector's own banners (Serving Soon / That's a
                    // wrap / address CTA) already communicate the empty state.
                    // Only the no-address CTA below remains, since it's the only
                    // path to add an address from here.
                    if (!noLocation) return null;

                    // When DateSessionSelector is already showing the address CTA
                    // via allUnavailable + noAddress, suppress the duplicate below.
                    if (allSessionsClosedToday) return null;

                    return (
                      <div className="col-12 text-center my-5">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "12px",
                            padding: "24px 16px",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "18px",
                              fontWeight: "600",
                              color: "#2c2c2c",
                              margin: 0,
                            }}
                          >
                            Where should we deliver?
                          </p>
                          <p
                            style={{
                              fontSize: "14px",
                              color: "#666",
                              margin: 0,
                              maxWidth: "280px",
                              lineHeight: "1.5",
                            }}
                          >
                            Add your delivery address to explore fresh meals
                            available near you.
                          </p>
                          <button
                            onClick={() => navigate("/location")}
                            style={{
                              marginTop: "4px",
                              backgroundColor: "#6B8E23",
                              color: "white",
                              padding: "12px 28px",
                              borderRadius: "10px",
                              border: "none",
                              fontSize: "15px",
                              fontWeight: "600",
                              cursor: "pointer",
                            }}
                          >
                            Add Address
                          </button>
                        </div>
                      </div>
                    );
                  })()}
              </div>
            </div>
          )}{" "}
          {/* end !isInWindow regular products */}
          {/* The "see tomorrow" / "back to today" switch now lives directly under the
              session cards in DateSessionSelector, per the new design. */}
        </div>
      </div>

      <MultiCartDrawer
        proceedToPlan={proceedToCheckout}
        groupedCarts={groupedCarts}
        overallSubtotal={overallSubtotal}
        overallTotalItems={overallTotalItems}
        onJumpToSlot={handleSelectionChange}
      />

      <Drawer
        placement="bottom"
        closable={false}
        onClose={onClose}
        open={open}
        key="bottom"
        height={600}
        className="description-product"
        style={{ zIndex: 99999 }}
        zIndex={99999}
      >
        <div className="modal-container-food">
          <button className="custom-close-btn" onClick={onClose}>
            ×
          </button>
          <div className="modern-food-item">
            <div className="food-image-container">
              <div className="image-loading-spinner" id="image-spinner"></div>
              {foodData?.Foodgallery?.length > 0 && (
                <img
                  src={`${foodData.Foodgallery[0].image2}`}
                  alt={foodData?.foodname}
                  className="modern-food-image"
                  onLoad={() => {
                    const spinner = document.getElementById("image-spinner");
                    const image = document.querySelector(".modern-food-image");
                    if (spinner) spinner.classList.add("hidden");
                    if (image) image.classList.add("loaded");
                  }}
                  onError={() => {
                    const spinner = document.getElementById("image-spinner");
                    if (spinner) spinner.classList.add("hidden");
                  }}
                />
              )}
              <div className="food-category-icon">
                {foodData?.foodcategory === "Veg" ? (
                  <img src={IsVeg} alt="IsVeg" className="isVegIcon" />
                ) : (
                  <img src={IsNonVeg} alt="IsNonVeg" className="isVegIcon" />
                )}
              </div>
            </div>
            <div className="food-details">
              <h2 className="food-title">{foodData?.foodname}</h2>
              <p className="food-description">{foodData?.fooddescription}</p>
              {(() => {
                const matchedLocation =
                  foodData?.locationPrice?.length > 0
                    ? foodData.locationPrice[0]
                    : {
                        Remainingstock: 0,
                        hubPrice: foodData.hubPrice || foodData.basePrice || 0,
                        preOrderPrice: foodData.preOrderPrice || 0,
                        basePrice: foodData.basePrice || 0,
                      };
                const productOffer = getProductOffer(foodData);
                const slotKey = `${selectedDate.toISOString().split("T")[0]}|${selectedSession.toLowerCase()}`;
                const hasOfferInCart = isOfferAlreadyAppliedInCart(slotKey);
                const showOfferPrice =
                  (!user || (offerStatusLoaded && ordersLoaded)) &&
                  productOffer &&
                  !hasOfferInCart &&
                  !productOffer.isBlocked;
                const eff = getEffectivePrice(
                  foodData,
                  matchedLocation,
                  foodData?.session,
                );
                const currentPrice =
                  showOfferPrice && productOffer?.offerPrice
                    ? productOffer.offerPrice
                    : eff.price;
                const originalPrice = eff.price;
                const stockCount = matchedLocation?.Remainingstock || 0;

                return (
                  <>
                    <div className="pricing-section">
                      <div className="pricing-display">
                        <span className="current-price">₹{currentPrice}</span>
                        {showOfferPrice && (
                          <span
                            className="original-price"
                            style={{ marginLeft: "10px" }}
                          >
                            ₹{originalPrice}
                          </span>
                        )}
                      </div>
                      {/* <div className="availability-banner">
                        {stockCount > 0 ? (
                          <>
                            {showOfferPrice && (
                              <BiSolidOffer
                                color="green"
                                style={{ marginRight: "5px" }}
                              />
                            )}
                            {productOffer &&
                              productOffer.customerType !== undefined && (
                                <span
                                  style={{
                                    fontSize: "11px",
                                    marginLeft: "5px",
                                  }}
                                >
                                  {productOffer.customerType === 0
                                    ? "(First Order Only)"
                                    : productOffer.customerType === 1
                                      ? "(Up to 1 Order)"
                                      : `(Up to ${productOffer.customerType} orders)`}
                                </span>
                              )}
                          </>
                        ) : (
                          "Sold Out"
                        )}
                      </div> */}
                    </div>
                    {/* {getCartQuantity(foodData?._id) > 0 ? (
                      <div className="increaseBtn">
                        <div
                          className="faplus"
                          onClick={() => {
                            if (!(user && !address) && cutoffValidation.allowed)
                              decreaseQuantity(
                                foodData?._id,
                                productOffer,
                                matchedLocation,
                              );
                          }}
                          style={{
                            opacity:
                              (user && !address) || !cutoffValidation.allowed
                                ? 0.5
                                : 1,
                            pointerEvents:
                              (user && !address) || !cutoffValidation.allowed
                                ? "none"
                                : "auto",
                          }}
                        >
                          <FaMinus />
                        </div>
                        <div className="faQuantity">
                          {getCartQuantity(foodData?._id)}
                        </div>
                        <div
                          className="faplus"
                          onClick={() => {
                            if (!(user && !address) && cutoffValidation.allowed)
                              increaseQuantity(
                                foodData?._id,
                                productOffer,
                                foodData,
                                matchedLocation,
                              );
                          }}
                          style={{
                            opacity:
                              (user && !address) || !cutoffValidation.allowed
                                ? 0.5
                                : 1,
                            pointerEvents:
                              (user && !address) || !cutoffValidation.allowed
                                ? "none"
                                : "auto",
                          }}
                        >
                          <FaPlus />
                        </div>
                      </div>
                    ) : stockCount > 0 && gifUrl !== "Closed.gif" ? (
                      <button
                        className="add-to-cart-btn"
                        onClick={() =>
                          addCart1(foodData, productOffer, matchedLocation)
                        }
                        disabled={
                          (user && !address) || !cutoffValidation.allowed
                        }
                        style={{
                          opacity:
                            (user && !address) || !cutoffValidation.allowed
                              ? 0.5
                              : 1,
                          cursor:
                            (user && !address) || !cutoffValidation.allowed
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <span className="add-to-cart-btn-text">Add</span>
                        <span className="add-to-cart-btn-icon">
                          <FaPlus />
                        </span>
                      </button>
                    ) : (
                      <button
                        className={
                          gifUrl === "Closed.gif" || !cutoffValidation.allowed
                            ? "add-to-cart-btn-disabled"
                            : "sold-out-btn"
                        }
                        disabled
                      >
                        <span className="add-to-cart-btn-text">
                          {gifUrl === "Closed.gif"
                            ? "Closed"
                            : !cutoffValidation.allowed
                              ? "Orders Closed"
                              : "Sold Out"}
                        </span>
                      </button>
                    )} */}
                  </>
                );
              })()}
            </div>
          </div>
        </div>
      </Drawer>

      {/* ── Combos modal ──
          A menu sheet, not a product grid: one row per combo, no imagery, with the
          same veg mark / price / quantity control the grid cards use. Every action
          here calls the exact same cart handlers, so cart + checkout are unchanged. */}
      <Modal
        show={showCombosModal}
        onHide={() => setShowCombosModal(false)}
        dialogClassName="combos-modal-dialog"
        contentClassName="combos-modal-content"
        backdropClassName="combos-modal-backdrop"
      >
        <div className="combos-modal-header">
          <div className="combos-modal-grabber" />
          <div className="combos-modal-heading">
            <h5 className="combos-modal-title">Customisable Combos</h5>
            <p className="combos-modal-subtitle">
              {comboItems.length} combo{comboItems.length === 1 ? "" : "s"}{" "}
              available for {selectedSession}
            </p>
          </div>
          <button
            type="button"
            className="combos-modal-close"
            onClick={() => setShowCombosModal(false)}
            aria-label="Close"
          >
            <img src={cross} alt="" />
          </button>
        </div>

        <Modal.Body className="combos-modal-body">
          {comboItems.length === 0 ? (
            <div className="combos-modal-empty">
              <img src={dishImg} alt="" />
              <p>No combos available for this slot.</p>
            </div>
          ) : (
            comboItems.map((item, i) => {
              const matchedLocation = item.locationPrice?.[0] || {
                Remainingstock: 0,
                hubPrice: item.hubPrice || item.basePrice || 0,
                preOrderPrice: item.preOrderPrice || 0,
                basePrice: item.basePrice || 0,
              };

              // Identical offer/price resolution to the grid cards above, so a
              // combo never shows a price the cart would disagree with.
              const productOffer = getProductOffer(item);
              const slotKey = `${selectedDate.toISOString().split("T")[0]}|${selectedSession.toLowerCase()}`;
              const hasOfferInCart = isOfferAlreadyAppliedInCart(slotKey);
              const offerDataReady =
                !user || (offerStatusLoaded && ordersLoaded);
              const showOfferPrice =
                offerDataReady &&
                productOffer &&
                !hasOfferInCart &&
                !productOffer.isBlocked;

              const { price: effectivePrice } = getEffectivePrice(
                item,
                matchedLocation,
                item?.session,
              );
              const selectedDateISO = selectedDate.toISOString();
              const cartItem = Carts.find(
                (c) =>
                  c?.foodItemId === item?._id &&
                  c.deliveryDate === selectedDateISO &&
                  c.session === selectedSession,
              );

              let displayPrice = effectivePrice;
              let strikePrice = null;

              if (cartItem && typeof cartItem.totalPrice === "number") {
                if (cartItem.offerApplied) {
                  displayPrice = Math.round(cartItem.totalPrice);
                  if (cartItem.Quantity > 1 && cartItem.regularPrice) {
                    strikePrice = Math.round(
                      cartItem.regularPrice * cartItem.Quantity,
                    );
                  }
                } else if (showOfferPrice && productOffer?.offerPrice) {
                  displayPrice = productOffer.offerPrice;
                  strikePrice = effectivePrice;
                } else {
                  displayPrice = Math.round(cartItem.totalPrice);
                }
              } else if (showOfferPrice && productOffer?.offerPrice) {
                displayPrice = productOffer.offerPrice;
                strikePrice = effectivePrice;
              }

              const qty = getCartQuantity(item?._id);
              const actionsLocked = (user && !address) || !isOrderingAllowed;

              return (
                <div className="combo-row" key={item._id?.toString() || i}>
                  <div className="combo-row-info">
                    <img
                      src={item?.foodcategory === "Veg" ? IsVeg : IsNonVeg}
                      alt={item?.foodcategory === "Veg" ? "Veg" : "Non-veg"}
                      className="combo-row-vegicon"
                    />
                    <div className="combo-row-text">
                      <p className="combo-row-name">{item?.foodname}</p>
                      {item?.unit && (
                        <p className="combo-row-desc">{item.unit}</p>
                      )}
                      <div className="combo-row-price">
                        {strikePrice && (
                          <span className="combo-row-price-strike">
                            ₹{strikePrice}
                          </span>
                        )}
                        <span className="combo-row-price-main">
                          ₹{displayPrice}
                        </span>
                        {showOfferPrice && strikePrice && (
                          <span className="offer-percentage-badge">
                            {Math.round(
                              ((strikePrice - displayPrice) / strikePrice) *
                                100,
                            )}
                            % OFF
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="combo-row-action">
                    {qty === 0 ? (
                      <button
                        className={`add-to-cart-btn combo-row-add ${
                          actionsLocked ? "disabled-btn" : ""
                        }`}
                        onClick={() =>
                          addCart1(item, productOffer, matchedLocation)
                        }
                        disabled={actionsLocked}
                        style={{
                          opacity: actionsLocked ? 0.5 : 1,
                          cursor: actionsLocked ? "not-allowed" : "pointer",
                        }}
                      >
                        <div className="pick-btn-text">
                          <span className="pick-btn-text1">ADD</span>
                        </div>
                        <span className="add-to-cart-btn-icon">
                          <FaPlus />
                        </span>
                      </button>
                    ) : (
                      <button className="increaseBtn combo-row-qty">
                        <div
                          className="faplus"
                          onClick={() =>
                            actionsLocked
                              ? null
                              : decreaseQuantity(
                                  item?._id,
                                  productOffer,
                                  matchedLocation,
                                )
                          }
                          style={{
                            opacity: actionsLocked ? 0.5 : 1,
                            pointerEvents: actionsLocked ? "none" : "auto",
                          }}
                        >
                          <FaMinus />
                        </div>
                        <div className="faQuantity">{qty}</div>
                        <div
                          className="faplus"
                          onClick={() =>
                            actionsLocked
                              ? null
                              : increaseQuantity(
                                  item?._id,
                                  productOffer,
                                  item,
                                  matchedLocation,
                                )
                          }
                          style={{
                            opacity: actionsLocked ? 0.5 : 1,
                            pointerEvents: actionsLocked ? "none" : "auto",
                          }}
                        >
                          <FaPlus />
                        </div>
                      </button>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </Modal.Body>

        <div className="combos-modal-footer">
          <button
            className="combos-modal-cta"
            onClick={() => setShowCombosModal(false)}
          >
            ADD
          </button>
        </div>
      </Modal>

      {/* <div style={{ marginBottom: "80px" }}>
        <Footer />
      </div> */}
      <BottomNav />
    </div>
  );
};

export default Home;
